import {map} from 'lodash'

export const heIL = {
    confirm: 'אישור',
    common: {
        replace: 'החלף',
        remove: 'הסר',
        optional: 'אופציונלי',
    },
    login: {
        identifier: 'מזהה',
        password: 'סיסמא',
        login: 'התחברות',
        verificationCodeFromSMS: 'קוד אימות שקיבלת',
        messageWasSentToSMS: (key, {last4digits}) => `הודעת SMS נשלחה למספר המסתיים בספרות ${last4digits}`,
        messageWasSentToEMAIL: (key, {maskedEmail}) => `דוא"ל נשלח לכתובת המייל ${maskedEmail}`,
        checkSpamMessage: ' אם את/ה לא מוצא/ת את קוד האימות, אנא בדוק/י',
        spamFolder: 'בתיקיית הספאם',
        validate: 'אימות',
        resendCode: 'שלח שוב',
        sendCode: 'שלח קוד אימות',
        helloX: (key, {name}) => `שלום ${name}`,
        otpDeliveryMethod: 'איך תרצה/י לקבל את קוד האימות?',
        sendBySMS: 'SMS',
        sendByEmail: 'דוא"ל',
        sendByWhatsApp: 'וואטסאפ',
        messageWasSentToWhatsApp: (key, {last4digits}) => `הודעת וואטסאפ נשלחה למספר המסתיים בספרות ${last4digits}`,
        chooseVerificationMethod: 'בחר/י איך תרצה/י לקבל את קוד האימות:',
        noEmailContactManager: 'המייל שלך לא רשום במערכת - פנה/י למנהל/ת שלך לקבלת עזרה',
        noPhoneContactManager: 'הפלאפון שלך לא רשום במערכת - פנה/י למנהל/ת שלך לקבלת עזרה',
    },
    otpLogin: {
        sendToEmail: 'מייל',
        sendToPhone: 'SMS',
        sendToWhatsApp: 'וואטסאפ',
        emailAddress: 'כתובת מייל',
        phoneNumber: 'מספר פלאפון',
        phonePlaceholder: 'הזן מספר טלפון',
        invalidPhoneNumber: 'מספר טלפון לא תקין',
        sendVerificationCode: 'שלח קוד אימות',
        title: 'התחברות עם קוד אימות',
        selectCompany: 'בחר/י חברה',
        selectCompanySubtitle: 'נמצאת רשום/ה במספר חברות. אנא בחר/י איזו חברה תרצה/י להתחבר אליה:',
        backToContactInfo: 'חזרה להזנת פרטי קשר',
    },
    changePassword: {
        currentPassword: 'סיסמא נוכחית',
        password: 'סיסמא חדשה',
        repeatPassword: 'חזרה על הסיסמא חדשה',
        changePassword: 'שנה סיסמא',
        weakPassword: 'סיסמא חלשה מידי, סיסמא חייבת להכיל לפחות אות גדולה אחת ומספר אחד ולהיות באורך של לפחות 8 תווים',
        newPasswordsDoesNotMatch: 'הסיסמאות לא זהות',
        pleaseFillAllFields: 'נא למלא את כל התאים הנדרשים'
    },
    logout: 'התנתק',
    menuItems: {
        logout: 'התנתק',
        changePassword: 'שנה סיסמא',
        adminPanel: `לוח מנהל/ת`,
        home: 'מסך הבית',
        myOrgs: 'היחידות הארגוניות שלי',
        learningCenter: 'מרכז הלמידה',
        users: 'משתמשים',
        reports: 'דוחות',
        settings: 'הגדרות',
        learningManagement: 'ניהול למידה',
        filesManagement: 'ניהול קבצים',
        knowledgeCenter: 'מרכז הידע',
        operation: 'טפסים ומידע',
        superAdmin: {
            courses: 'ניהול לומדות',
            customers: 'ניהול לקוחות',
            organizations: 'ניהול יחידות ארגוניות',
            users: 'ניהול משתמשים',
            dashboards: 'דוחות',
            partners: 'ניהול שותפים',
            assets: 'ניהול נכסים',
            courseTemplates: 'תבניות לומדות'
        },
    },
  routingTabs: {
      featureRequiredTooltip: (key, { tabName }) => `להרחבת רכיב ${tabName} במערכת יש לפנות למפתחת הלמידה שלכם או למייל info@weezbee.ai`
  },
    languages: {
        label: 'בחר/י שפה',
        languageKeys: {
            heIL: 'עברית',
            enUS: 'English',
            arIL: 'العربية',
            ruRU: 'Русский',
            ptPT: 'Português'
        }
    },
    n8nChat: {
        title: 'Buzz AI',
        subtitle: 'סוכן הבינה המלאכותית של WeezBee',
        greeting: 'היי, אני Buzz AI - סוכן הבינה המלאכותית של WeezBee. איך אני יכול לעזור?',
        newConversation: 'שיחה חדשה',
        inputPlaceholder: 'שלח הודעה כאן...',
        closeChat: 'סגור צ\'אט'
    },
    learningCenter: {
        title: 'מרכז הלמידה שלי',
        subTitle: 'משימות וסטטוס הביצוע שלהן',
        loading: 'טוען משימות...',
        coursesToDo: 'לומדות שטרם סיימתי',
        coursesCompleted: 'לומדות שסיימתי',
        noCoursesToDo: 'אין לומדות שטרם סיימתי',
        noCoursesCompleted: 'אין לומדות שסיימתי',

        // Generic sign docs (keep for backward compatibility)
        signDocsToDo: 'משימות פתוחות',
        signDocsCompleted: 'משימות שסיימתי',
        noSignDocsToDo: 'אין משימות פתוחות',
        noSignDocsCompleted: 'אין משימות שסיימתי',

        // Archived SignDocs
        archivedSignDocs: 'משימות בארכיון',
        noArchivedSignDocs: 'אין משימות בארכיון',
        versionsCount: (key, { count }) => `${count} גרסאות`,
        versions: 'גרסאות',
        archivedVersions: 'גרסאות בארכיון',
        versionsNotFound: 'הגרסאות לא נמצאו',
        versionsNotFoundDescription: 'לא נמצאו גרסאות בארכיון עבור משימה זו',

        // Document specific titles - READ_AND_SIGN_DOC_PDF
        pdfDocsToDo: 'מסמכים לחתימה',
        pdfDocsCompleted: 'מסמכים שנחתמו',
        noPdfDocsToDo: 'אין מסמכים לחתימה',
        noPdfDocsCompleted: 'אין מסמכים שחתמתי',

        // WATCH_AND_SIGN_YOUTUBE_LINK & WATCH_AND_SIGN_VIMEO_LINK
        videoLinksToDo: 'סרטונים לצפייה',
        videoLinksCompleted: 'סרטונים שצפיתי בהם',
        noVideoLinksToDo: 'אין סרטונים לצפייה',
        noVideoLinksCompleted: 'אין סרטונים שצפיתי בהם',

        // WATCH_AND_SIGN_VIDEO_FILE
        videoFilesToDo: 'סרטונים לצפייה',
        videoFilesCompleted: 'סרטונים שצפיתי בהם',
        noVideoFilesToDo: 'אין סרטונים לצפייה',
        noVideoFilesCompleted: 'אין סרטונים שצפיתי בהם',

        // REGULAR_COURSE
        regularCoursesToDo: 'לומדות לביצוע',
        regularCoursesCompleted: 'לומדות שביצעתי',
        noRegularCoursesToDo: 'אין לומדות לביצוע',
        noRegularCoursesCompleted: 'אין לומדות שביצעתי',

        // CANVA_PRESENTATION
        canvaPresentationsToDo: 'מצגות לצפייה',
        canvaPresentationsCompleted: 'מצגות שצפיתי בהן',
        noCanvaPresentationsToDo: 'אין מצגות לצפייה',
        noCanvaPresentationsCompleted: 'אין מצגות שצפיתי בהן',

        // EXAM
        examsToDo: 'מבחנים שטרם סיימתי',
        examsCompleted: 'מבחנים שסיימתי',
        noExamsToDo: 'אין מבחנים שטרם סיימתי',
        noExamsCompleted: 'אין מבחנים שסיימתי',

        // LEARNING_PATH
        learningPathsToDo: 'מסלולי הכשרה שטרם סיימתי',
        learningPathsCompleted: 'מסלולי הכשרה שסיימתי',
        noLearningPathsToDo: 'אין מסלולי הכשרה שטרם סיימתי',
        noLearningPathsCompleted: 'אין מסלולי הכשרה שסיימתי',

        // PODCAST
        podcastsToDo: 'פודקאסטים להאזנה',
        podcastsCompleted: 'פודקאסטים שהאזנתי להם',
        noPodcastsToDo: 'אין פודקאסטים להאזנה',
        noPodcastsCompleted: 'אין פודקאסטים שהאזנתי להם',

        // AUDIO_FILE
        audioFilesToDo: 'קבצי שמע להאזנה',
        audioFilesCompleted: 'קבצי שמע שהאזנתי להם',
        noAudioFilesToDo: 'אין קבצי שמע להאזנה',
        noAudioFilesCompleted: 'אין קבצי שמע שהאזנתי להם',

        // FRONTAL_COURSE
        frontalCoursesToDo: 'הרצאות פרונטליות להשתתפות',
        frontalCoursesCompleted: 'הרצאות פרונטליות שהשתתפתי בהן',
        noFrontalCoursesToDo: 'אין הרצאות פרונטליות להשתתפות',
        noFrontalCoursesCompleted: 'אין הרצאות פרונטליות שהשתתפתי בהן',

        // ONLINE_COURSE
        onlineCoursesToDo: 'קורסים מקוונים לביצוע',
        onlineCoursesCompleted: 'קורסים מקוונים שביצעתי',
        noOnlineCoursesToDo: 'אין קורסים מקוונים לביצוע',
        noOnlineCoursesCompleted: 'אין קורסים מקוונים שביצעתי',

        // PRESENTATION
        presentationsToDo: 'מצגות לצפייה',
        presentationsCompleted: 'מצגות שצפיתי בהן',
        noPresentationsToDo: 'אין מצגות לצפייה',
        noPresentationsCompleted: 'אין מצגות שצפיתי בהן',

        // ARTICLE
        articlesToDo: 'מאמרים לקריאה',
        articlesCompleted: 'מאמרים שקראתי',
        noArticlesToDo: 'אין מאמרים לקריאה',
        noArticlesCompleted: 'אין מאמרים שקראתי',

        // SURVEY
        surveysToDo: 'סקרים למילוי',
        surveysCompleted: 'סקרים שמילאתי',
        noSurveysToDo: 'אין סקרים למילוי',
        noSurveysCompleted: 'אין סקרים שמילאתי',

        // LINK
        linksToDo: 'קישורים לצפייה',
        linksCompleted: 'קישורים שצפיתי בהם',
        noLinksToDo: 'אין קישורים לצפייה',
        noLinksCompleted: 'אין קישורים שצפיתי בהם',

        // UPLOAD_DOCUMENT
        uploadsToDo: 'מסמכים שטרם אושרו',
        uploadsCompleted: 'מסמכים שאושרו',
        noUploadsToDo: 'אין מסמכים להעלאה',
        noUploadsCompleted: 'אין מסמכים שהעליתי',

        noOpenTasks: 'אין משימות פתוחות',

        // Existing learningCenter translations continue
        tabs: {
            myCourses: 'לומדות',
            courses: 'הדרכות פרונטליות ומקוונות',
            mySignDocs: 'מסמכים לחתימה',
            myTasks: 'משימות פתוחות',
            myCertifications: 'הסמכות',
            myExams: 'מבחנים',
            myWeezbeeCourses: 'קורסים',
            learningPaths: 'מסלולי הכשרה',
            myVideos: 'סרטונים',
            myAudioFiles: 'קבצי שמע',
            myLinks: 'קישורים',
            surveys: 'סקרים',
            myPresentations: 'מצגות',
            uploads: 'העלאות מסמכים',
            myContent: 'ההכשרות שלי',
            archived: 'ארכיון',
        },
        searchMyContent: 'חיפוש תוכן',
        searchMyContentPlaceholder: 'חפש לפי שם...',
        filterByType: 'סינון לפי סוג',
    },
    settingsPage: {
        title: 'הגדרות',
        subTitle: 'התאימו את המערכת',
        subTitleBold: 'לצרכי החברה שלך',
        buttons: {
            updateLogo: "עדכון לוגו",
            updateOrgName: "עדכון שמות יחידות ארגוניות",
            addOrg: "הוספת יחידות ארגוניות",
            updateNotes: "עדכון פתקים לעובדים",
            adminInstructionCourse: "לומדת הדרכת מנהלים",
        },
        editNotesModal: {
            title: 'עריכת פתקים לעובדים',
        },
        addOrganizationModal: {
            organizationsList: 'רשימת יחידות ארגוניות',
            useCommaSeparatedValues: 'אם ברצונך להוסיף מספר יחדיות ארגוניות ניתן להזין ערכים מופרדים בפסיק, לדוגמא: "כספים, הנהלת חשבונות, פיתוח תוכנה"',
            title: 'הוספת יחידות ארגוניות',
        },
        editOrganizationsNames: 'עריכת שמות יחידות ארגוניות',
        editOrganizationName: 'עריכת שם יחידה ארגונית',
        createNote: 'יצירת פתק חדש',
        newNoteTitle: 'פתק חדש',
        SMSQuota: {
            title: 'קרדיט הודעות',
            quota: 'הודעות שנרכשו',
            sent: (key, {
                sent,
                quota
            }) => `לידיעתך, עד היום נשלחו ${sent} הודעות ונותרו לך ${quota} הודעות לשימוש עתידי`,
            lastSMSWasSentOn: (key, {date}) => `שליחת ההודעות האחרונה מהמערכת בוצעה בתאריך ${date}`,
        },
        generalSettings: {
            title: 'כללי'
        },
        reminders: {
            title: 'תזכורות',
            course: 'לומדה',
            signDoc: 'מסמך לחתימה',
            watchVideo: 'צפייה בסרטון',
            listenAudio: 'האזנה לקובץ שמע',
            canvaPresentation: 'צפייה ב Canva',
            exam: 'מבחן',
            learningPath: 'מסלול הכשרה',
            link: 'קישור',
            survey: 'סקר',
            weezbeeCourse: 'קורס מקוון',
            frontalCourse: 'הרצאה פרונטלית',
            onlineCourse: 'קורס מקוון',
            uploadDocument: 'מסמך להעלאה',
        },
        admins: {
            title: 'מנהלים',
            subTitle: 'ניהול והגדרות'
        },
        setup:{
            title: 'הגדרות הקמה'
        },
        deletedUsers: {
            title: 'משתמשים שנמחקו'
        },
        organizationalUnits: {
            title: 'יחידות ארגוניות',
        }
    },
    HomePage: {
        courseLegend: {
            completed: 'סיימתי',
            inProgress: 'בתהליך',
            notStarted: 'לא התחלתי'
        },
    },
    home: {
        title: 'לומדות אפשריות עבורך',
        faq: 'שאלות נפוצות',
        welcome: 'ברוכים הבאים',
        // learningSubtitle:(key,{companyName}) => `לסביבת הלמידה האישית שלכם, עבור חברת ${companyName}`,
        learningSubtitle: "לסביבת הלמידה האישית, עבור",
        userChartLabels: {
            finishedCourses: 'קורסים שסיימתי',
            inProgressCourses: 'קורסים בתהליך',
            notStartedCourses: 'קורסים שלא התחלתי',
            label: 'התקדמות קורסים'
        },
        superAdmin: 'ממשק מנהל מערכת',
    },
    faq: {
        question1: 'האם ניתן לחזור ללומדות בכל שלב?',
        answer1: 'כן. אפשר ללמוד בקצב אישי מכל מקום ובכל זמן, מהפלאפון הנייד או מהמחשב (ממליצים לפתוח בדפדפן Google Chrome). שימו לב, ברגע שמתחילים לומדה יש לסיים לבצע אותה מאותו המכשיר.',
        question2: 'מה עושים בסיום הלומדות?',
        answer2: 'בסיום הלומדה יש ללחוץ על כפתור הסיום ולאשר שביצעת את הלומדה. יש לוודא שלא נשארו משימות פתוחות.',
        question3: 'צריכים עזרה?',
        answer3: 'לתמיכה ניתן לשלוח הודעת Whatsapp למספר 052-9663062, או בכתובת האימייל info@nakarmedic.co.il',
    },
    gender: {
        male: 'זכר',
        female: 'נקבה'
    },

    OrganizationsPage: {
        title: 'היחידות הארגוניות שלי',
        subTitle: 'ניהול והגדרות',
        organizations: 'יחידות ארגוניות בניהולי',
        importUsersFile: "ייבא קובץ משתמשים",
        editLogo: 'ערוך לוגו',
        dropLogoHere: 'גרור לוגו לכאן',
        currentLogo: 'לוגו נוכחי',
        changeForAllMyOrganizations: 'שנה לכל היחידות הארגוניות בניהולי',
        logoWillBeChangedForAllOrgs: '**הלוגו ישתנה לכל היחידות הארגוניות בניהולך',

    },
    UsersPage: {
        title: 'משתמשים',
        subTitle: 'ניהול והגדרות',
        userRowCourseMenu: {
            buttons: {
                addToCourse: 'רשום משתמש',
                removeFromCourse: 'הסר רישום משתמש',
            }
        },
        userRowSignDocMenu: {
            buttons: {
                addToSignDoc: 'רשום משתמש',
                removeFromSignDoc: 'הסר רישום',
                markCompleted: 'סמן כהושלם',
                unmarkCompleted: 'בטל השלמה',
            },
            tooltips: {
                sessionNotToday: 'ניתן לסמן נוכחות רק ביום המפגש'
            }
        }
    },
    organizationUserTable: {
        headers: {
            name: "שם",
            permissions: "הרשאה",
            identifier: "מזהה"
        }
    },
    userType: {
        ADMIN: 'מנהל/ת',
        USER: "משתמש"
    },
    note: {
        title: 'כותרת',
        content: 'תוכן',
        delete: 'מחיקת פתק',
        assignToAllOrganizations: 'שייך לכל היחידות הארגוניות',
        removeFromAllOrganizations: 'הסר מכל היחידות הארגוניות',
        deleteNoteConfirmation: {
            title: 'מחיקת פתק',
            message: 'האם את/ה בטוח/ה שברצונך למחוק את הפתק?',
            noteName: 'שם הפתק',
            deleteNote: 'מחיקת פתק'
        }
    },
    organization: {
        organizationName: 'שם היחידה הארגונית',
    },
    courseCard: {
        youAreDone: `סיימת את הלומדה`,
        finishBy: (key, {finishByDate}) => `יש לסיים עד ל  ${finishByDate}`,
        youAreDoneWatchAgain: 'לצפייה חוזרת',
        goToCourse: 'מעבר ללומדה'
    },
    // courseProgress: {
    //     notStarted: 'לא התחלתי',
    //     inProgress: 'בתהליך',
    //     finished: 'סיימתי!',
    // },
    ReportsPage: {
        title: 'דוחות',
        subTitle: 'צפו בסטטוס הביצוע של העובדים',
        // subTitleBold: 'בתצורה גרפית.',
        courseLegend: {
            completed: 'סיימו',
            inProgress: 'בתהליך',
            notStarted: 'לא התחילו',
            failed: 'נכשלו'
        },
        coursesStats: {
            title: 'סטטוס ביצוע לכל אחת מהלומדות',
        },
        signDocStats: {
            title: {
                course: 'סטטוס ביצוע לכל אחת מהלומדות',
                signDocs: 'סטטוס חתימות לכל אחד מהמסמכים'
            },
            exportToExcel: 'ייצוא לאקסל',
            exporting: 'מייצא...',
            exportCurrentFilters: 'ייצוא סינונים נוכחיים',
            graphs: {
                usersPerformanceNumbers: (key, {taskCount = 0}) => `מספר משתמשים לפי סטטוס ביצוע ${taskCount ? `(${taskCount} משימות)` : ''}`,
                usersPerformancePercent: (key, {taskCount = 0}) => `אחוז משתמשים לפי סטטוס ביצוע ${taskCount ? `(${taskCount} משימות)` : ''}`,
                performanceNumberByOrg: (key, {orgsCount = 0}) => `מספר ביצועים ביחידה הארגונית ${orgsCount ? `(${orgsCount} יחידות ארגוניות)` : ''}`,
                performancePercentByOrg: (key, {orgsCount = 0}) => `אחוז ביצוע ביחידה הארגונית ${orgsCount ? `(${orgsCount} יחידות ארגוניות)` : ''}`,
                signDocsCount: ' מסמכים לחתימה',
                activeCourseCount: 'פרטי למידה פעילים',
                usersCount: 'משתמשים',
                usersWithActiveTasks: 'משתמשים עם משימה פעילה',
                allSignDocsOfACompanyCount: 'פרטי למידה והדרכה',
                examPassRate: 'אחוז העוברים/נכשלים במבחן',
                examPassCountRate: 'מספר העוברים/נכשלים במבחן',
                info: {
                    activeCourseCount: 'סה"כ פרטי למידה עם תאריך סיום עתידי (לומדות, מסמכים לחתימה ומשימות צפיה)',
                    usersCount: 'סה"כ משתמשים',
                    usersWithActiveTasks: 'סה"כ משתמשים עם לפחות משימה פעילה אחת',
                    allSignDocsOfACompanyCount: 'סה"כ פריטי למידה (לומדות, מסמכים לחתימה ומשימות צפיה)',
                    performanceNumberByOrg: 'סה"כ משימות שבוצעו מתוך כלל המשימות הנצברות\n (משימות נצברות = מספר פריטי הלמידה והדרכה כפול כמות המשתמשים שהוקצו לכל פריט)',
                    performancePercentByOrg: 'סה"כ משימות שבוצעו בכל יחידה ארגונית',
                    examPassRate: 'סה"כ משתמשים שעברו/נכשלו במבחן מתוך המשתמשים שביצעו את המבחן',
                    examPassCountRate: 'סה"כ משתמשים שעברו/נכשלו במבחן מתוך כלל המשתמשים שביצעו את המבחן',
                }
            }
        },
        tabs: {
            dashboard: 'דשבורד',
            allReports: 'פרטי למידה והדרכה',
            courses: 'לומדות',
            signDocs: 'מסמכים לחתימה',
            exams: 'מבחנים',
            learningPaths: 'מסלולי הכשרה',
            generatedReports: 'דוחות שהופקו',
            videos: 'וידאו',
            KnowledgeCenter: 'מרכז הידע',
            operation: 'תפעול',
            audioFiles: 'קבצי שמע',
            presentations: 'מצגות',
            links: 'קישורים',
            surveys: 'סקרים',
            courseReports: 'הדרכות פרונטליות ומקוונות',
            userProgress: 'התקדמות משתמשים',
            certifications: 'הסמכות',
        }
    },
    surveyReports: {
        title: 'דוחות סקרים',
        subtitle: (key, { count }) => `מציג ${count} סקרים עם נתוני השיבות`,
        card: {
            progress: 'התקדמות',
            type: 'סוג',
            actions: 'פעולות',
            anonymous: 'אנונימי',
            identified: 'לא אנונימי',
            viewFullReport: 'הצג דוח',
            responseRate: 'שיעור מענה',
            assignedTo: 'מוקצה לארגונים',
            assigned: 'מוקצים',
        },
        noSurveys: {
            title: 'אין סקרים להצגה',
            message: 'לא נמצאו סקרים ביחידה הארגונית שנבחרה. נסה לבחור יחידה ארגונית אחרת או צור סקר חדש.'
        }
    },
    surveyCharts: {
        chartType: {
            bar: 'עמודות',
            pie: 'עוגה'
        },
        metadata: {
            totalResponses: (key, { count }) => `סה"כ תשובות: ${count}`,
            responseFromUsers: (key, { responses }) => `${responses} תשובות`,
            questionType: (key, { type }) => `סוג שאלה: ${type}`,
            anonymous: 'אנונימי'
        },
        noData: {
            title: 'אין נתונים להצגה עבור שאלה זו',
            message: 'לא נמצאו תשובות לשאלה זו'
        },
        tooltips: {
            responses: 'תשובות',
            responseCount: (key, { count }) => `${count} תשובות`,
            percentage: (key, { percent }) => `${percent}%`
        }
    },
    courseReports: {
        title: 'דוחות קורסים',
        defaultTitle: 'קורס',
        subtitle: (key, { completed, assigned, rate }) => `${completed} מתוך ${assigned} השלימו (${rate}%)`,
        organization: 'יחידה ארגונית',
        allOrganizations: 'כל היחידות הארגוניות',
        completed: 'השלימו',
        notFound: 'קורס לא נמצא',
        card: {
            sessionDate: 'תאריך המפגש',
            noSessionDate: 'לא נקבע תאריך',
            viewFullReport: 'צפייה בדוח מפורט',
            completionRate: 'אחוז השלמה'
        },
        downloadReport: 'הורדת דוח משימות',
        noCourses: {
            title: 'אין קורסים זמינים',
            message: 'לא נמצאו קורסים עבור היחידות הארגוניות שנבחרו'
        }
    },
    signDocReports: {
        searchLabel: 'חיפוש',
        searchPlaceholder: 'חיפוש לפי שם...',
        filterByType: 'סינון לפי סוג תוכן',
        noSignDocs: {
            title: 'אין תוכן זמין',
            message: 'לא נמצא תוכן עבור היחידות הארגוניות שנבחרו'
        }
    },
    surveyResults: {
        title: 'תוצאות סקר',
        organization: 'ביחידות ארגוניות',
        allOrganizations: 'בכל היחידות הארגוניות',
        subtitle: (key, { responses, assigned, rate }) => `${responses} מתוך ${assigned} השיבו (${rate}%)`,
        backToSurveys: 'חזרה לרשימת סקרים',
        questionsTitle: 'תוצאות שאלות',
        questionNumber: (key, { number }) => `שאלה מספר ${number}`,
        freeTextDefault: (key, { count }) => `התקבלו ${count} תגובות בטקסט חופשי`,
        notFound: 'סקר לא נמצא',
        defaultTitle: 'תוצאות סקר',
        freeTextResponses: {
            title: 'תגובות בטקסט חופשי',
            noResponses: 'לא התקבלו תגובות בטקסט חופשי לשאלה זו'
        },
        meta: {
            organization: 'יחידה ארגונית',
            totalQuestions: 'מספר שאלות',
            type: 'סוג סקר',
            completionRate: 'שיעור השלמה'
        },
        tabs: {
            results: 'תוצאות הסקר',
            users: 'משתמשים'
        }
    },
    learningPathReport: {
        status: {
            completed: 'הושלם',
            inProgress: 'בתהליך',
            notStarted: 'לא התחיל'
        }
    },
    surveyUsers: {
        columns: {
            fullName: 'שם מלא',
            firstName: 'שם פרטי',
            lastName: 'שם משפחה',
            idNumber: 'מספר תעודת זהות',
            employeeId: 'מספר עובד',
            status: 'סטטוס',
            showUserAnswer: 'הצג תשובות'
        },
        actions: {
            showAnswer: 'הצג תשובות'
        },
        noUsers: {
            title: 'אין משתמשים להצגה',
            message: 'לא נמצאו משתמשים עבור הסקר ביחידה הארגונית שנבחרה.'
        }
    },
    userSurveyAnswers: {
        modalTitle: (key, { userName }) => `תשובות המשתמש ${userName}`,
        columns: {
            question: 'שאלה',
            questionType: 'סוג השאלה',
            userAnswer: 'תשובת המשתמש',
            isCorrect: 'נכון'
        },
        notApplicable: 'לא רלוונטי',
        noAnswer: 'לא נענה',
        unknownQuestion: 'שאלה לא ידועה',
        unknownQuestionType: 'סוג שאלה לא ידוע',
        unknownOption: 'אפשרות לא ידועה',
        invalidRating: 'דירוג לא תקין',
        loading: 'טוען תשובות...',
        error: 'שגיאה בטעינת התשובות',
        noQuestions: 'לא נמצאו שאלות'
    },
    courseProgressMgmnt: {
        notStarted: 'לא התחיל/ה',
        inProgress: 'בתהליך',
        finished: 'סיים/ה',
        attended: 'נכח/ה',
        noShow: 'לא נכח/ה',
        registered: 'נרשם/ה',
        completedOn: 'תאריך חתימה: ',
        completedOnCourse: 'תאריך ביצוע: ',
        by: 'על ידי ',
        manual: 'ידני',
        finishBy: 'לסיום עד: ',
        score: 'ציון',
    },
    examScore: 'ציון',
    LearningManagementPage: {
        title: 'ניהול למידה',
        subTitle: 'הוספה, עריכה ומחיקה',
        addCourse: 'הוספת לומדה',
        editCourse: 'עריכת לומדה',
        deleteCourse: 'מחיקת לומדה',
        courseName: 'שם הלומדה',
        courseDescription: 'תיאור הלומדה',
        courseImage: 'תמונת הלומדה',
        createKnowledgeSource: 'יצירת מקור ידע',
        createQuestionnaire: 'יצירת שאלון',
        createExam: 'יצירת מבחן',
        createLearningPath: 'יצירת מסלול הכשרה',
        courseCard: {
            editCourse: 'עריכת לומדה',
        },
        signDocCard: {
            editSignDoc: {
                READ_AND_SIGN_DOC_PDF: 'עריכת מסמך',
                WATCH_AND_SIGN_YOUTUBE_LINK: 'עריכת משימת צפיה',
                WATCH_AND_SIGN_VIMEO_LINK: 'עריכת משימת צפיה',
                WATCH_AND_SIGN_VIDEO_FILE: 'עריכת משימת צפיה',
                AUDIO_FILE: 'עריכת משימת האזנה',
                REGULAR_COURSE: 'עריכת לומדה',
                CANVA_PRESENTATION: 'עריכת מצגת',
                LEARNING_PATH: 'עריכת מסלול למידה',
                SURVEY: 'ערוך סקר',
                LINK: 'עריכת הלינק לצפייה',
                EXAM: 'עריכת מבחן',
                QUESTIONNAIRE: 'עריכת שאלון',
                WEEZBEE_COURSE:'עריכת קורס',
                UPLOAD_DOCUMENT: 'עריכת משימת העלאה',
                FRONTAL_COURSE: 'עריכת הרצאה פרונטלית',
                ONLINE_COURSE: 'עריכת קורס מקוון'
            },
            deleteModal: {
                title: 'מחיקת מסמך',
                text: 'האם הנכם בטוחים שברצונכם למחוק את המסמך? פעולה זו אינה ניתנת לביטול',
                confirm: 'מחיקת מסמך',
                cancel: 'ביטול',
                signDocName: 'שם המסמך',
                deleteAllVersionsCheckbox: 'מחק את כל הגרסאות של המסמך',
                warningAllVersions: '⚠️ שימו לב: מחיקת מסמך זה תמחק את כל הגרסאות של המסמך'
            },
            versionManagement: 'ניהול גרסאות',
            uplodingSignDoc: {
                uploadInProgress: 'הקובץ בתהליך העלאה',
                uploadFailed: 'תהליך ההעלאה נכשל'
            }
        },
        users: {
            buttons: {
                downloadCsv: 'הורדה',
                downloadCsvForOrganizations: 'הורדת דו״ח משימות למשתמשים מהיחידות הארגוניות שנבחרו',
                downloadUserDetailsForOrganizations: 'הורדת קובץ פרטי משתמשים מהיחידות הארגוניות שנבחרו',
                downloadSelectedUsers: 'הורדת דו״ח משימות למשתמשים שנבחרו',
                downloadCsvForOrganization: 'הורדת קובץ משתמשים מהיחידה הארגונית שנבחרה',
                downloadCsvForAllOrganizations: 'הורדת קובץ משתמשים מכל היחידות הארגוניות בניהולי',
            },
            messages: {
                exportStarted: 'הייצוא התחיל. מעבר לדוחות...',
                exportFailed: 'הייצוא נכשל. נסה שוב.',
                noUsersSelected: 'אנא בחר משתמשים לייצוא',
            }
        },
        courseManagement: 'ניהול לומדות',
        signDocManagement: 'ניהול מסמכים',
        noSignDocs: 'אין מסמכים להצגה',
        noSearchResults: 'לא נמצאו תוצאות לחיפוש שלך',
        noSearchResultsHint: 'נסה להתאים את מונח החיפוש או נקה את החיפוש כדי לראות את כל הפריטים',
        tabs: {
            signDocs: 'מסמכים לחתימה',
            courses: 'לומדות',
            users: 'משתמשים',
            certifications: 'הסמכות',
            pendingApprovals: 'מסמכים לאישור',
            courseAttendance: 'נוכחות בקורסים',
            tasks: 'פרטי למידה והדרכה',
            knowledgeCenter: 'מרכז הידע',
            operation: 'תפעול',
            questionnaire: 'שאלונים',
            weezBeeCourses: 'קורסים',
            exams: 'מבחנים',
            learningPath: 'מסלולי למידה/ הכשרה',
            videoLinks: 'סרטונים',
            audioFiles: 'קבצי שמע',
            presentations: 'מצגות',
            links: 'קישורים',
            surveys: 'סקרים',
            uploads: 'העלאת מסמכים',
            frontalCourses: 'הרצאות פרונטליות',
            onlineCourses: 'קורסים מקוונים',
            archive: 'ארכיון',
        },
        searchTasks: 'חיפוש משימות',
        searchTasksPlaceholder: 'חיפוש לפי שם...',
        filterByType: 'סינון לפי סוג',
        filterByTypePlaceholder: 'בחר סוגים...',
        allTypes: 'כל הסוגים',
        typeNames: {
            READ_AND_SIGN_DOC_PDF: 'מסמכים לחתימה',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'וידאו',
            WATCH_AND_SIGN_VIMEO_LINK: 'וידאו',
            WATCH_AND_SIGN_VIDEO_FILE: 'וידאו',
            VIDEOS: 'וידאו',
            REGULAR_COURSE: 'לומדות',
            CANVA_PRESENTATION: 'מצגות קנבה',
            EXAM: 'מבחנים',
            LEARNING_PATH: 'מסלולי למידה',
            SURVEY: 'סקרים',
            ARTICLE: 'מאמרים',
            AUDIO_FILE: 'קבצי שמע',
            LINK: 'קישורים',
            PODCAST: 'פודקאסטים',
            FRONTAL_COURSE: 'קורסים פרונטליים',
            ONLINE_COURSE: 'קורסים מקוונים',
            PRESENTATION: 'מצגות',
            WEEZBEE_COURSE: 'לומדות מערכת',
            UPLOAD_DOCUMENT: 'העלאת מסמכים',
        },
        addLearningObject: 'הוספת פרטי \nלמידה והדרכה',
        honeycombTitle: 'פרטי למידה והדרכה',
    },
    signDocVersionManagement: {
        title: 'ניהול גרסאות',
        managingVersionsFor: 'ניהול גרסאות עבור',
        createNewVersionButton: 'יצירת גרסה חדשה',
        allVersions: 'כל הגרסאות',
        archive: 'העבר לארכיון',
        currentVersion: 'גרסה נוכחית',
        versionNumber: 'מספר גרסה',
        versionDetails: 'פרטי גרסה',
        viewDetails: 'הצג פרטים',
        errorTitle: 'שגיאה בטעינת גרסאות',
        notFound: 'המסמך לא נמצא',
        notFoundDescription: 'המסמך שחיפשת לא קיים או שהוסר',
        noVersions: 'אין גרסאות להצגה',
        created: 'נוצר בתאריך',
        createdBy: 'נוצר על ידי',
        expiredAt: 'פג בתאריך',
        type: 'סוג',
        status: {
            label: 'סטטוס',
            ACTIVE: 'פעילה',
            ARCHIVED: 'בארכיון',
            SCHEDULED: 'מתוזמנת',
        },
        toggleStatus: 'לחץ להחלפת סטטוס (פעיל/ארכיון)',
        stats: {
            assigned: 'משוייכים',
            completed: 'הושלם',
            inProgress: 'בתהליך',
            completionRate: 'אחוז השלמה',
            totalUsers: 'סה״כ משתמשים'
        },
        statistics: {
            progressDone: 'התקדמות',
            usersAssigned: 'משתמשים משוייכים',
            usersCompleted: 'משתמשים שהשלימו',
            usersInProgress: 'משתמשים בתהליך'
        },
        viewStatistics: 'הצג סטטיסטיקות',
        userStatistics: 'סטטיסטיקות משתמשים',
        returnToData: 'חזור לנתונים',
        goToReports: 'עבור לדוחות',
        edit: 'עריכה',
        preview: 'תצוגה מקדימה',
        tabs: {
            versions: 'גרסאות',
            recurringDetails: 'הגדרות חזרתיות'
        },
        recurring: {
            title: 'הגדרות חזרתיות',
            notConfigured: 'מסמך זה לא מוגדר כחזרתי',
            frequency: 'תדירות חזרה',
            nextVersionDate: 'תאריך גרסה הבאה',
            editNextVersionDate: 'עריכת תאריך הגרסה הבאה',
            changeDate: 'שנה תאריך',
            everyXMonths: (key, { value }) => `כל ${value} חודש${value === 1 ? '' : 'ים'}`,
            everyXYears: (key, { value }) => `כל ${value} שנ${value === 1 ? 'ה' : 'ים'}`,
            badge: 'משימה מחזורית',
        }
    },
    signDocPreviewPage: {
        title: 'תצוגה מקדימה של תוכן',
        loading: 'טוען תצוגה מקדימה...',
        errorTitle: 'שגיאה בתצוגה מקדימה',
        errorDescription: 'לא ניתן לטעון את תצוגת התוכן. ייתכן שלמסמך אין תוכן שהועלה עדיין.',
        noContent: 'אין תוכן זמין לתצוגה מקדימה עבור מסמך זה.',
        backToVersions: 'חזרה לגרסאות',
    },
    editCourseModal: {
        title: 'עריכת לומדה',
        courseName: 'שם הלומדה',
        courseDescription: 'תיאור הלומדה',
        courseImage: 'תמונת הלומדה',
        save: 'שמור שינויים',
        edit: {
            courseName: 'שם הלומדה',
            courseDescription: 'תיאור הלומדה',
            dateEditNotification: 'באפשרותך לקבוע תאריך סיום אחיד לכל הרשומים לקורס בכל היחידות הארגוניות בניהולך, שינויים שתבצע כאן ידרסו שינויים פרטניים שבוצעו עבור משתמשים'
        },
        dateModal: {
            title: 'קביעת תאריך סיום',
            timeAndTimezone: 'עד 00:00 באיזור זמן: '
        }
    },
    editUserCourseModal: {
        title: (key, {userName, courseName}) => `קביעת תאריך סיום עבור קורס \"${courseName}\" למשתמש \"${userName}\"`,
        dateEditNotification: 'באפשרותך לקבוע תאריך סיום למשתמש, שינוי זה יהיה בתוקף על עוד לא תשנה את תאריך הסיום של כלל היחידה הארגונית'
    },
    AppSideMenu: {
        welcome: `ברוכים הבאים`,
        legalLinks: {
            termsOfUse: 'תנאי שימוש',
            privacyPolicy: 'מדיניות פרטיות'
        }
    },
    superAdmin: {
        cronJobs: {
            sectionTitle: 'משימות מחזוריות',
            runRecurringRenewal: 'הרץ חידוש משימות מחזוריות',
            running: 'פועל...',
            renewalSuccess: 'חידוש משימות מחזוריות הושלם בהצלחה',
            renewalError: 'חידוש מחזורי נכשל. בדוק לוגים בשרת.',
        },
        assets: {
            title: 'ניהול נכסים',
            columns: {
                fileName: 'שם קובץ',
                type: 'סוג',
                company: 'חברה',
                createdBy: 'נוצר על ידי',
                tags: 'תגיות',
                lastModified: 'עודכן לאחרונה',
                download: 'הורדה',
                thumbnail: 'תצוגה מקדימה'
            },
            filters: {
                companyName: 'שם חברה',
                type: 'סוג קובץ',
                all: 'הכל',
                image: 'תמונה',
                video: 'וידאו',
                clear: 'נקה סינון',
                generalBank: 'בנק כללי'
            },
            fileTypes: {
                image: 'תמונה',
                video: 'וידאו',
                file: 'קובץ'
            },
            download: 'הורד קובץ',
            downloadError: 'שגיאה בהורדת הקובץ',
            loading: 'טוען...',
            thumbnailError: 'שגיאה בטעינת תצוגה מקדימה',
            thumbnail: 'תצוגה מקדימה של הקובץ',
            upload: {
                title: 'העלאה לבנק הכללי',
                uploadButton: 'העלאת נכס',
                cancel: 'ביטול',
                upload: 'העלאה',
                dragDrop: 'גרור ושחרר קובץ כאן או לחץ לבחירת קובץ',
                supportedTypes: 'סוגי קבצים נתמכים: תמונות (.jpg, .png, .gif) וסרטונים (.mp4, .mov, .avi)',
                presentationName: 'שם תצוגה',
                presentationNamePlaceholder: 'הזן שם לקובץ',
                description: 'תיאור',
                descriptionPlaceholder: 'הזן תיאור לקובץ',
                noFileSelected: 'אנא בחר קובץ להעלאה',
                error: 'אירעה שגיאה בעת העלאת הקובץ',
                uploading: 'מעלה'
            },
            tags: {
                editTags: 'עריכת תגיות',
                enterTagsPlaceholder: 'הזן תגיות מופרדות בפסיקים',
                tagsHelperText: 'תגיות עוזרות לארגן ולמצוא נכסים בקלות',
                andMoreTags: (key, { count }) => `ועוד ${count}`,
                noTags: 'אין תגיות',
                save: 'שמור',
                cancel: 'ביטול'
            }
        },
        courseTemplates: {
            title: 'תבניות לומדות',
            placeholder: 'פונקציונליות תבניות הלומדות תהיה זמינה בקרוב. דף זה יאפשר לך ליצור, לערוך ולנהל תבניות לומדות שניתן להשתמש בהן בכל הפלטפורמה.',
            columns: {
                templateName: 'שם תבנית',
                templateSubject: 'נושא',
                description: 'תיאור',
                createdBy: 'נוצר על ידי',
                isPubliclyAccessible: 'נגיש לציבור',
                isReady: 'מוכן',
                actions: 'פעולות'
            },
            buttons: {
                createTemplate: 'יצירת תבנית חדשה',
                editTemplate: 'עריכת תבנית',
                duplicateTemplate: 'שכפול תבנית',
                deleteTemplate: 'מחיקת תבנית',
                viewTemplate: 'צפייה בתבנית'
            },
            searchPlaceholder: 'חיפוש תבניות...',
            noTemplates: 'לא נמצאו תבניות. צור את התבנית הראשונה שלך על ידי לחיצה על הכפתור למעלה.',
            fetchError: 'טעינת התבניות נכשלה. אנא נסה שוב מאוחר יותר.',
            searchError: 'חיפוש התבניות נכשל. אנא נסה שוב מאוחר יותר.',
            deleteError: 'מחיקת התבנית נכשלה. אנא נסה שוב מאוחר יותר.',
            confirmDelete: 'האם אתה בטוח שאתה רוצה למחוק את התבנית הזו?'
        },
        generateAPIKeyModal: {
            generateAPIKey: 'צור מפתח API',
            modalTitle: 'מפתח API',
        },
        generateClientCreds: {
            generateClientCreds: 'צור מפתח לקוח',
            modalTitle: 'מפתח לקוח',
            clientId: 'מזהה לקוח',
            clientSecret: 'סוד לקוח'
        },
        editPartnerCompaniesModal: {
            modalTitle: 'עריכת חברות לשותף',
            selectAllCompanies: 'בחר/י את כל החברות',
            selectCompanies: 'בחר/י חברות',
            save: 'שמור חברות'
        },
        editFFModal: {
            modalTitle: "עריכת פיצ'רים לחברה",
            editFeatures: "עריכת פיצ'רים",
            paths: {
                basic: 'בסיסי',
                creator: 'יוצר',
                enterprise: 'ארגוני'
            },
            deals: {
                messaging: 'הודעות ותקשורת',
                contentTypes: 'סוגי תוכן',
                courses: 'קורסים והדרכות',
                automation: 'אוטומציה',
                advanced: 'פיצ\'רים מתקדמים',
                organization: 'ניהול ארגוני',
                system: 'הגדרות מערכת'
            },
            dealStatus: {
                allEnabled: 'הכל פעיל',
                partiallyEnabled: 'פעיל חלקית',
                disabled: 'לא פעיל'
            },
            featureFlags: {
                automationFF: 'אוטומציה',
                smsFF: 'SMS',
                whatsappFF: 'Whatsapp',
                emailFF: 'אימייל',
                signDocsFF: 'משימות',
                sendWelcomeMessageFF: 'שליחת הודעות למשתמש חדש',
                signDocsReadAndSignDocPdfFF: 'חתימה על PDF',
                signDocsWatchAndSignYoutubeLinkFF: 'אישור צפיה Youtube',
                signDocsWatchAndSignVimeoLinkFF: 'אישור צפיה Vimeo',
                signDocsWatchAndSignVideoFileFF: 'אישור צפיה קובץ וידאו',
                signDocCanvaPresentationFF: 'מצגת Canva',
                regularCourseFF: 'לומדות',
                frontalCourseFF: 'הדרכות פרונטליות',
                onlineCourseFF: 'הדרכות מקוונות',
                notifyNewTaskToUserFF: 'הודעה על משימה חדשה',
                knowledgeCenterFF: 'מרכז הידע',
                orgAdminMgmtFF: 'ניהול הרשאות אדמינים',
                subAdminCanCreateOrgFF: 'תת-אדמין יכול ליצור יחידות ארגוניות',
                languagesFF: 'שפות',
                examsFF: 'מבחנים',
                weezbeeCourseFF: 'קורס ויזבי',
                AIFF: 'AI',
                learningPathFF: 'מסלול הכשרה',
                signDocsAudioFileFF: 'קובץ שמע',
                linkFF: 'קישורים',
                surveyFF: 'סקרים',
                recurringAutomationFF: 'אוטומציה חוזרת',
                uploadDocumentFF: 'העלאת מסמכים',
                certificationFF: 'הסמכות',
                phoneE164MigrationFF: 'פורמט טלפון בינלאומי (E.164)',
                bulkUserRefactorFF: 'ניהול משתמשים מרובים V2',
                operationModeFF: 'מצב תפעול (שינוי שם מרכז הידע)',
                mustDoComplianceFF: 'חובה לעמידה בדרישות'
            }
        },
        allUsersTable: {
            columns: {
                firstName: 'שם פרטי',
                lastName: 'שם משפחה',
                email: 'אימייל',
                phone: 'טלפון',
                roles: 'תפקידים',
                identifier: 'מזהה',
                organization: 'יחידה ארגונית',
                id: 'מזהה',
                companyName: 'חברה',
                yes: 'כן',
                no: 'לא',
                isSuperAdmin: 'מנהל מערכת',
                isCompanyAdmin: 'מנהל/ת חברה',
                isDeleted: 'נמחק',
                deleted: 'נמחק',
                edit: 'עריכה',
                permanentlyDelete: 'מחיקה לצמיתות',
                loginUrl: 'קישור להתחברות',
                userCreatedSmsDate: 'תאריך הודעת התנעה',
                loginAs: 'התחבר כמשתמש',
            },
            buttons: {
                downloadCsvForOrganization: 'הורדת קובץ Excel ליחידה ארגונית',
                downloadCsvForAllOrganizations: 'הורדת קבצי Excel לכל היחידות הארגוניות בניהולי',
                downloadCsvForOrganizationSuccess: 'הקבצים שלך יהיו מוכנים להורדה בקרוב תחת "תפריט -> ניהול קבצים"',
                deleteUsers: 'מחיקת משתמשים',
                edit: 'עריכה',
            }
        },
        allOrgsTable: {
            columns: {
                orgName: 'שם היחידה הארגונית',
                taxIdentifier: 'מזהה',
                companyId: 'מזהה חברה',
                orgAddress: 'כתובת',
                orgContactInfo: 'פרטי קשר',
                id: 'מזהה',
                companyName: 'שם החברה',
                delete: 'מחיקה',
            },
            deleteOrg: 'מחיקת יחידה ארגונית',
            deleteOrgTitle: 'מחיקת יחידה ארגונית: ',
            deleteOrgText: 'בטוח שברצונכם למחוק את היחידה הארגונית',
            deleteOrgConfirm: 'מחיקת יחידה ארגונית',


        },
        createNewCourse: {
            title: 'יצירת לומדה חדשה',
            docName: 'שם הלומדה',
            courseDescription: 'תיאור הלומדה',
            create: 'צור לומדה',
            companyName: 'שם החברה',
            dropZipHere: 'גרור קובץ zip של לומדה לכאן או לחץ לבחירת קובץ',
            modalTitle: 'יצירת לומדה חדשה',
            assignToAllOrganizations: 'הקצה לכל הארגונים',
            assigned: 'הוקצה בהצלחה לכל הארגונים',
            organizationsTable: {
                orgName: 'שם היחידה הארגונית',
                addOrganization: 'הוספת קורס ליחידה הארגונית',
                removeOrganization: 'הסרת קורס מהיחידה הארגונית',
                onlyOneCompanyPerCourse: 'ניתן להוסיף קורס לחברה אחת בלבד, לכן לא ניתן כעת לשנות בחירת חברה',
            }
        },
        createNewPartner: {
            modalTitle: 'יצירת שותף חדש',
            identifier: 'מזהה',
            partnerName: 'שם השותף',
            contactEmail: 'אימייל ליצירת קשר',
            contactPhone: 'טלפון ליצירת קשר',
            contactFirstName: 'שם פרטי ליצירת קשר',
            contactLastName: 'שם משפחה ליצירת קשר',
            createPartner: 'צור שותף',
            detailsTitle: 'מלאו את פרטי השותף',
            clientId: 'מזהה לקוח',
            clientSecret: 'סוד לקוח',
        },
        createNewCustomer: {
            modalTitle: 'יצירת לקוח חדש',
            companyName: 'שם החברה',
            userPrefix: 'קידומת משתמשים (ייחודי לכל חברה - באנגלית בלבד)',
            identifier: 'מזהה',
            contactEmail: 'אימייל ליצירת קשר',
            contactName: 'שם ליצירת קשר',
            contactPhone: 'טלפון ליצירת קשר',
            userCreationTitle: 'צור משתמש ראשוני לחברה',
            detailsTitle: 'מלאו את פרטי החברה',
            userPassword: 'סיסמא למשתמש (אנגלית בלבד)',
            userIdentifier: 'מזהה למשתמש (אנגלית בלבד)',
            createCompany: 'צור חברה',
            userNameNoteNoPrefix: '*לפני שתוכל להזין שם משתמש יש להזין קידומת משתמשים',
            userNameNote: (key, {companyUsersPrefix, userIdentifier}) => {
                return '*שם המשתמש שיווצר בפועל יהיה: ' + companyUsersPrefix + "-" + (userIdentifier || '"מזהה משתמש"')
            },
            userPrefixError: 'קידומת משתמשים חייבת להיות באנגלית בלבד',
            userFirstName: 'שם פרטי',
            userLastName: 'שם משפחה',
            contactFirstName: 'שם פרטי ליצירת קשר',
            contactLastName: 'שם משפחה ליצירת קשר',
            countryCode: 'מדינה',
            generateAPIKey: 'צור מפתח API',
        },
        editCourse: {
            courseName: 'שם הלומדה',
            docName: 'שם הלומדה',
            courseDescription: 'תיאור הלומדה',
            companyName: 'שם החברה',
            description: 'תיאור הלומדה',
            dropZipHere: 'גרור קובץ zip של לומדה לכאן או לחץ לבחירת קובץ',
            dropZipNote: '**שימו לב, אתם במצב עריכה, לכן אם קובץ zip כבר קיים עבור הלומדה, העלאה נוספת תדרוס את הקיים*',
            saveChanges: 'שמור שינויים',
            modalTitle: 'עריכת לומדה',
        },
        editCustomer: {
            modalTitle: 'עריכת לקוח',
            adminUserDetails: 'פרטי משתמש ראשי',
            detailsTitle: 'עריכת פרטי החברה',
            organizationsTitle: 'יחידות ארגוניות של הלקוח',
            addOrganizations: 'הוספת יחידות ארגוניות ללקוח',
            addOrganizationModal: {
                organizationsList: 'רשימת יחידות ארגוניות',
                useCommaSeparatedValues: 'הזן ערכים מופרדים בפסיק, לדוגמא: "כספים, הנהלת חשבונות, פיתוח תוכנה"',
                title: 'הוספת יחידות ארגוניות ללקוח',
            },
            mfaForAllUsers: 'אימות דו שלבי לכל משתמשי החברה',
        },
        coursesTable: {
            columns: {
                courseName: 'שם המשימה',
                description: 'תיאור המשימה',
                edit: 'עריכה',
                type: 'סוג המשימה',
                editCourse: 'עריכת לומדה',
                companyName: 'שם החברה',
                remove: 'מחיקה',
                uploadStatus: 'סטטוס העלאה',
            },
            uploadStatus: {
                READY: 'מוכן',
                UPLOADING: 'מעלה...',
                FAILED: 'נכשל',
            }
        },
        customersTable: {
            downloadReport: 'הורד דוח חברות',
            downloadingReport: 'מוריד דוח...',
            reportGenerated: 'דוח נוצר בהצלחה',
            reportError: 'שגיאה ביצירת הדוח',
            columns: {
                companyName: 'שם החברה',
                taxIdentifier: 'מזהה',
                edit: 'עריכה',
                editCompany: 'עריכת חברה',
                smsQuota: 'קרדיט הודעות',
                userQuota: 'מכסת משתמשים',
                activeUsers: 'משתמשים פעילים',
                featureFlags: "פיצ'רים",
                storageQuotaMB: 'אחסון (MB)',
                editQuota: 'עריכת מכסות',
                welcomeMessage: 'שלח הודעת חיבור ראשוני',
                welcomeMessageSent: 'הודעה נשלחה',
                loginAs: 'התחבר כמשתמש',
                delete: 'מחק',
            },
            deleteCompany: {
                button: 'מחק',
                title: 'מחיקת חברה לצמיתות',
                warning: 'פעולה זו מוחקת לצמיתות את החברה וכל הנתונים שלה. לא ניתן לבטל פעולה זו.',
                backupNote: 'רשומות הלמידה של החברה (נתוני UserSignDoc) מגובות ל-S3 לפני המחיקה.',
                confirmLabel: 'הקלד את שם החברה או המזהה כדי לאשר:',
                confirmPlaceholder: 'שם החברה או מזהה',
                cancel: 'ביטול',
                confirm: 'מחק חברה',
                deleting: 'מוחק...',
                success: 'החברה נמחקה בהצלחה',
                error: 'מחיקת החברה נכשלה. אנא נסה שוב.'
            },
            welcomeMessage: {
                confirmTitle: 'שליחת הודעת חיבור ראשוני לחברת',
                confirmMessage: 'האם את/ה בטוח/ה שברצונך לשלוח הודעות חיבור ראשוני לכל המשתמשים בחברה זו?',
                detailsTitle: 'פרטי הודעת החיבור הראשוני',
                sentDate: 'תאריך שליחה:',
                sentBy: 'נשלח על ידי:',
                company: 'חברה:'
            },
            quota: {
                editQuota: 'עריכת מכסות',
                editQuotaTitle: 'עריכת מכסות לחברה',
                editCredits: 'עריכת קרדיטים',
                editUserQuota: 'מכסת משתמשים',
                MessagesCreditsToEdit: 'קרדיטי הודעות',
                storageQuotaToEdit: 'מקום אחסון ב MB',
            }
        },
        partnersTable:{
            columns: {
                partnerName: 'שם השותף',
                generateAPIKey: 'צור מפתח API',
                edit: 'עריכה',
                clientSecretExpiresAt: 'תפוגת מפתח לקוח',
            }
        },
        reports: {
            title: 'דוחות',
            tabs: {
              companies: 'חברות',
            },
            companiesInfo: {
                totalUsersCount: 'סה"כ משתמשים פעילים במערכת',
                newUsersThisMonthCount: 'משתמשים חדשים החודש',
                totalCompaniesCount: 'סה"כ חברות במערכת',
                newCompaniesThisMonthCount: 'חברות חדשות החודש',
                columns: {
                    companyName: 'שם החברה',
                    userQuota: 'מכסת משתמשים',
                    activeUsers: 'משתמשים פעילים',
                    createdAt: 'נוצר בתאריך',
                    organizations: 'כמות יחידות ארגוניות',
                    admins: 'כמות מנהלי מערכת',
                    courses: 'כמות לומדות ומסמכים',
                    assignmentCompletion: 'אחוז סיום משימות',
                    lastMemoSentDate: 'תאריך תזכורת אחרונה',
                    smsCount: 'כמות הודעות שנשלחו',
                    smsQuota: 'כמות הודעות שנשארו',
                    lastAdminLoginDate: 'תאריך התחברות אחרון לאדמין',
                    adminIdentifier: 'מזהה אדמין',
                }
            }
        }
    },
    dataGrid: {
        filters: {
            search: {
                input: 'חיפוש',
            },
        },
        filterLabels: {
            course: 'קורס',
            organization: 'יחידה ארגונית',
            company: 'חברה',
            signDoc: 'משימות',
            fileType: 'סוג קובץ'
        },
        footer: {
            rowsSelected: (key, {count}) => count === 1 ? 'נבחרה שורה אחת' : `נבחרו ${count} שורות`
        }
    },
    importUsersPage: {
        downloadExample: 'הורדת קובץ תבנית ליצירת משתמשים',
        downloadUsersAsCSV: 'הורדת משתמשים כקובץ CSV',
    },
    importUsersModal: {
        title: 'ייבוא / עריכה מרובה',
        tabs: {
            importUsers: {
                title: 'ייבוא משתמשים והוספת יחידות',
            },
            reorganizeUsers: {
                title: 'ייבוא משתמשים ושינוי יחידות',
            },
            rebootUsers: {
                title: 'אתחול משתמשי החברה',
            }
        },
        manyUsersMessage: 'נראה שישנם משתמשים רבים בקובץ, ייתכן שהייבוא יארך מספר דקות, לאחר לחיצה על יצירה, אנא השאירו את החלון פתוח עד לסיום הטעינה ולאחריה, חכו מספר דקות לפני שכל השינויים ישוקפו במערכת',
        users: {
            firstName: 'שם פרטי',
            lastName: 'שם משפחה',
            phone: 'טלפון',
            email: 'אימייל',
            idNumber: 'תעודת זהות',
            employeeId: 'מספר עובד',
            organizations: 'יחידות ארגוניות',
            organizationsAliases: ['יחידה ארגונית', 'ארגונים', 'ארגון', 'יחידות', 'יחידה'],
        },
        createUsers: 'יצירת/עריכת משתמשים',
        selectOrganization: 'בחרו יחידות ארגוניות עבורן יווצרו המשתמשים',
        selectOrganizationsToAdd: 'בחרו יחידות ארגוניות להוספה',
        organization: 'יחידה ארגונית',
        newUsersWillBeCreatedAndOrganizationsWillBeAddedToAllUsers: 'היחידות הארגוניות יתווספו לכל המשתמשים שימצאו בקובץ המצורף, משתמשים שלא קיימים יווצרו, משתמשים קיימים יעודכנו',
        newUsersWillBeCreatedAndOrganizationsWillBeOverride: 'היחידות הארגוניות ישונו עבור כל המשתמשים בקובץ המצורף (משתמשים יוסרו מיחידות שאינן מסומנות), משתמשים שלא קיימים יווצרו, משתמשים קיימים יעודכנו',
        errors: {
            missingMandatoryField: (key, {row}) => `*שדות חובה חסרים בשורה ${row}:`,
            twoSourcesForOrgs: 'לא ניתן לבחור יחידות ארגוניות משני מקורות, אנא הסירו את היחידות הארגוניות מהקובץ המיובא או מהבחירה בראש העמוד' ,
            removeOrgsFromFile: 'אנא הסירו את היחידות הארגוניות מהקובץ המיובא' ,
            missingSourceForOrgs: 'לא נבחרו יחידות ארגוניות למשתמשים, אנא בחרו יחידות ארגוניות מהבחירה בראש העמוד או הוסיפו יחידות ארגוניות על פי קובץ תבנית הייבוא',
            missingSourceForOrgsSelectFromMultiSelect: 'לא נבחרו יחידות ארגוניות למשתמשים, אנא בחרו יחידות ארגוניות מהבחירה בראש העמוד',
            noFirstNameColumn: 'הקובץ חייב לכלול עמודה בשם "First Name"',
            noLastNameColumn: 'הקובץ חייב לכלול עמודה בשם "Last Name"',
            emptyExcelFile: 'קובץ האקסל ריק או לא מכיל גיליון עבודה',
            invalidExcelFile: 'קובץ האקסל פגום או לא תקין, אנא בדוק את הקובץ ונסה שוב',
            unsupportedFileType: 'סוג הקובץ אינו נתמך. אנא העלה קובץ CSV או Excel (.xlsx, .xls)',
            missingColumn: (key, {columnName}) => `הקובץ חייב לכלול עמודה בשם "${columnName}"`,
        }
    },
    uploadBox: {
        uploading: 'מעלה קובץ...',
        uploaded: 'הקובץ הועלה בהצלחה',
        uploadFailed: 'הקובץ אינו תקין, אנא בדוק שגודל הקובץ וסוג הקובץ לא חורגים מן המותר',
        maxFileSize: (key, {maxFileSize}) => `גודל הקובץ המקסימלי המותר הוא ${maxFileSize}`,
        onlyFileTypes: (key, {fileTypes}) => `סוגי הקבצים המותרים להעלאה הם: ${map(fileTypes, fileType => `${fileType}`).join(', ')}`,
    },
    completedCoursePage: {
        title: 'סיום לומדה',
        subTitle: 'אנא אשר/י כי סיימת את הלומדה',
        buttons: {
            confirmCourseCompletion: 'אני מאשר/ת שסיימתי את הלומדה'
        },
        finishedSuccessfully: 'סיימת בהצלחה את הלומדה',
        oops: 'אופס...',
        youGotLost: 'נראה שאיבדת את דרכך, נווט/י בעזרת התפריט',
        courseCompletedSuccessfullyPopup: 'סיימת בהצלחה את הלומדה',
    },
    errors: {
        clientError: 'שגיאה בפרטים שהוזנו',
        serverError: 'שגיאה בפניית השרת',
        generalServerError: 'שגיאה כללית בפנייה לשרת, נסו לטעון מחדש את העמוד, אם הבעיה נמשכת פנו לתמיכה הטכנית',
        notFound: 'המשאב לא נמצא',
        forbidden: 'אין לך הרשאה לגשת למשאב זה',
        privateRouteUserNotLoggedIn: 'המשתמש אינו מחובר ולכן לא ניתן לראות את התכנים, אנא התחבר ולאחר מכן נסה שוב',
        session_expired: 'פג תוקף החיבור שלך למערכת. אנא התחבר שוב כדי להמשיך.',
        too_many_requests: 'שגיאה, ניסית יותר מידי פעמים, אנא נסה שוב מאוחר יותר',
        invalidInput: (key, { pattern }) => `זוהה הכנסת ערך לא חוקי נא לשנות אותו: ${pattern}`,
        noAdminUserFound: 'לא נמצא משתמש מנהל עבור חברה זו',
        popupBlocked: 'החלון החדש נחסם. אנא אפשר חלונות קופצים עבור אתר זה.',
        failedToGenerateLoginUrl: 'שגיאה ביצירת קישור התחברות',
        userNotFound: 'משתמש לא נמצא',
    },
    alertDialog: {
        ok: 'אישור',
        cancel: 'ביטול',
    },
    orphanedUsers: {
        filterLabel: 'ללא שיוך ארגוני',
        alertMessage: 'משתמשים פעילים אינם משויכים לאף יחידה ארגונית. כדי לתקן: בחר/י "ללא שיוך ארגוני" ברשימת היחידות הארגוניות, ולאחר מכן לחצ/י על עריכה עבור כל משתמש ושייכ/י אותו ליחידה ארגונית.',
    },
    createEditUserModal: {
        editPhone: 'עריכת טלפון',
        organizationsLabel: 'יחידות ארגוניות',
        selectAllOrganizations: 'בחר/י את כל היחידות הארגוניות',
        identifier: 'מזהה',
        createUser: 'יצירה',
        saveFailed: 'השמירה נכשלה. אנא נסה/י שוב.',
        titleCreate: 'יצירת/עדכון משתמש',
        titleEdit: 'עריכת משתמש',
        selectOrganization: 'בחירת יחידה ארגונית',
        firstName: 'שם פרטי',
        lastName: 'שם משפחה',
        idNumber: 'מספר תעודת זהות',
        employeeId: 'מספר עובד',
        phone: 'טלפון',
        email: 'אימייל',
        editUser: 'עריכת משתמש',
        deleteUserTitle: 'מחיקת משתמש',
        sendWelcomeMessageConfirm: 'שלח הודעה',
        deleteUserText: 'האם את/ה בטוח/ה שברצונך למחוק את המשתמש',
        deleteOrgConfirm: 'מחק משתמש',
        deleteUserButton: 'מחק משתמש',
        userIsCompanyAdmin: 'מנהל/ת בחברה',
        userIsOrgAdmin: 'מנהל/ת ביחידה ארגונית',
        userIsOrgAdminTooltip: 'כדי למחוק משתמש זה, תחילה יש להסיר אותו מתפקידי ניהול בכל היחידות הארגוניות',
        mfaRequired: 'נדרש אימות דו שלבי',
        sendWelcomeMessage: 'שליחת הודעת חיבור ראשוני למשתמשים',
        userDetails: 'המסמכים והלומדות שמשוייכים ל',
        save: 'שמירת/עדכון משתמש',
        userWillBeEditedIfPhoneExists: 'אם הטלפון כבר משוייך למשתמש בחברה, המשתמש והארגונים אליו הוא משוייך יעודכנו',
    },
    phoneEditModal: {
        title: 'עריכת מספר טלפון',
        phoneLabel: 'מספר טלפון',
        phonePlaceholder: 'הזן מספר טלפון',
        cancel: 'ביטול',
        save: 'שמירה',
        errors: {
            phone_already_exists: 'מספר הטלפון כבר קיים במערכת',
            phone_belongs_to_inactive_user: 'מספר הטלפון שייך למשתמש לא פעיל',
            invalid_phone_format: 'מספר טלפון לא תקין',
            no_permission: 'אין הרשאה לעדכן מספר טלפון',
            network_error: 'שגיאת רשת, נסה שוב',
            check_failed: 'בדיקת הזמינות נכשלה, נסה שוב',
        },
    },
    recurringAtEditModal: {
        title: 'עריכת תאריך הגרסה הבאה',
        dateLabel: 'תאריך הגרסה הבאה',
        disclaimer: 'שינוי תאריך הגרסה הבאה ייאכף על כל המשתמשים המשויכים למשימה זו.',
        cancel: 'ביטול',
        save: 'שמירה',
        errors: {
            saveFailed: 'שגיאה בעדכון התאריך, נסה שוב',
        },
    },
    allUsersTable: {
        columns: {
            fullName: 'שם מלא',
            email: 'אימייל',
            phone: 'טלפון',
            roles: 'תפקידים',
            idNumber: 'מספר תעודת זהות',
            employeeId: 'מספר עובד',
            organization: 'יחידה ארגונית',
            id: 'מזהה',
            edit: 'עריכה',
            delete: 'מחיקה',
            restore: 'שחזור משתמש',
            deleted: 'נמחק',
            sendWelcomeMessage: 'שליחת הודעת ברוך הבא',
            progress: 'התקדמות',
            notRegistered: 'לא רשום לקורס',
            loginAs: 'התחבר כמשתמש',
        },
            buttons: {
                deleteUsers: 'מחק משתמשים',
            },
            filters: {
            allUsers: 'כל המשתמשים',
            activeOnly: 'משתמשים פעילים בלבד',
            deletedOnly: 'משתמשים מחוקים בלבד',
        }
    },
    removeCourseFromCompanyCol: {
        deleteCourseButton: 'מחק לומדה',
        removeCourseTitle: 'מחיקת לומדה',
        removeCourseText: 'האם את/ה בטוח/ה שברצונך למחוק את הלומדה',
        removeCourseConfirm: 'מחק לומדה',
    },
    CourseReminderNotificationButton: {
        alerts: {
            reminderSent: 'התזכורות יצאו לדרך!',
            reminderNotSent: 'שגיאה בשליחת תזכורת',
            sentMessages: 'הודעות שנשלחו',
            notSentMessages: 'הודעות שלא נשלחו',
            notSentMessagesInfo: '* יכולות להיות שתי סיבות לכך שלא כל ההודעות נשלחו: חוסר בפרטי איש קשר או מספר סלולרי שגוי',
            sendToUsersWhoDidNotReceiveNotification: 'שלח תזכורת למשתמשים שלא קיבלו עד כה',
            sendToAllUsers: 'שלח תזכורת לכל משתמשי הקורס שטרם סיימו',
            error: 'שגיאה',
            company_has_no_sms_quota: 'אין לחברה מספיק קרדיטי הודעות זמינים, אנא צור קשר עם שירות לקוחות על מנת לרכוש חבילת הודעות',
            general_error: 'אירעה שגיאה בעת שליחת ההתראה, אנא נסה שוב מאוחר יותר'
        }
    },
    FilesManagementPage: {
        title: 'ניהול קבצים',
        subTitle: 'צפייה, הוספה ועריכה',
        fileManagementTable: {
            columns: {
                fileName: 'קישור להורדה',
                presentationName: 'שם לתצוגה',
                isReady: 'מוכן להורדה',
                companyName: 'חברה',
                organizationNames: 'יחידות ארגוניות',
                date: 'תאריך יצירה',
                createdByUser: 'נוצר ע"י',
            },
            download: 'הורדה',
            inProgress: 'בתהליך יצירה',
            ready: 'מוכן להורדה',
            allOrganizations: 'כל היחידות הארגוניות',
        }
    },
    SMSNotificationButton: {
        title: 'שליחת תזכורת',
        subTitle: 'באופן מיידי'
    },
    sendSMSModal: {
        title: 'את מי אנחנו מתזכרים?',
        sms: 'SMS',
        whatsapp: 'WhatsApp',
        email: 'Email',
        selectMessageDeliveryWay: 'ההודעות ישלחו באמצעות:',
        sendToOptions: {
            all: 'משתמשים שטרם ביצעו משימה ספציפית',
            onlyNotNotified: 'כל מי שטרם סיים את הלומדה ולא קיבל תזכורת',
            allWithAnyOpenTasks: 'משתמשים עם משימות פתוחות',
            knowledgeCenter: 'משתמשים עם משימת העשרה',
            pleaseSelect: 'אנא בחר/י את הקבוצה שברצונך לשלוח לה',
            label: 'למי?'
        },
        taskOptions: {
            label: 'איזו משימה?',
            pleaseSelect: 'אנא בחרו את הלומדה שברצונכם לשלוח תזכורת עבורה',
        },
        organizationOptions: {
            label: 'איזו יחידה ארגונית?',
            pleaseSelect: 'אנא בחרו את היחידה הארגונית שברצונכם לשלוח תזכורת עבורה',
        },
        smsStatusInformation: {
            statusTitle: 'מעולה!',
            statusUserToNotify: 'אז אנחנו מתזכרים סה"כ ',
            bySMS: 'באמצעות SMS',
            byWhatsApp: 'באמצעות WhatsApp',
            byEmail: 'באמצעות אימייל',
            statusCompanyQuota: 'לידיעתך, לאחר השליחה יישארו לך ',
            SMSForUse: 'הודעות לשימוש',
            employees: 'עובדים',
            theyWillReceiveItAsFollowing: 'שיקבלו את ההודעות בדרכים הבאות',
            existing: 'קיימים ',
            usersDontHaveEmails: ' משתמשים שאין להם מייל'
        },
        error: {
            noUsersToSendOnlyNotNotified: 'אין משתמשים לשליחה, כל המשתמשים שטרם סיימו את הלומדה קיבלו תזכורת',
            notEnoughSMS: 'אין לך מספיק קרדיטי הודעות זמינים, אנא צור קשר עם שירות לקוחות על מנת לרכוש חבילת הודעות',
            noUsersInCourse: 'אין משתמשים לשליחה, כל המשתמשים בקורס זה סיימו את הלומדה',
            youAreLeftWithQuota: 'נותרו לך עוד',
            youNeed: 'ונדרשים סה"כ',
            toCompleteTheProcess: 'להשלמת התהליך',
        },
        send: 'שלח'
    },
    SADeleteUsersModal: {
        title: 'מחיקת משתמשים',
        firstName: 'שם פרטי',
        lastName: 'שם משפחה',
        email: 'אימייל',
        phone: 'טלפון',
        employeeID: 'מזהה עובד',
        idNumber: 'תעודת זהות',
        organizations: 'יחידות ארגוניות',
        identifier: 'מזהה',
        message: (key, {userCount}) => `האם את/ה בטוח/ה שברצונך למחוק את ${userCount} המשתמשים הבאים?`,
        deleteUsers: 'מחק משתמשים',
        fetchError: 'שגיאה בטעינת נתוני משתמשים',
        deleteError: 'שגיאה במחיקת משתמשים',
        deleting: 'מוחק...',

        // Confirmation view
        confirmMessage: (key, {userCount}) => `האם את/ה בטוח/ה שברצונך למחוק ${userCount} משתמשים?`,
        confirmHint: 'משתמשים שהם מנהלי ארגון לא יימחקו ויוצגו בדוח התוצאות.',

        // Results view
        resultsTitle: 'תוצאות מחיקה',
        successTitle: 'המחיקה הושלמה בהצלחה',
        noDeletedTitle: 'לא נמחקו משתמשים',

        deletedUsersTitle: 'משתמשים שנמחקו',
        skippedUsersTitle: 'משתמשים שלא נמחקו',

        // Result messages
        successMessageOnly: (key, {deleted}) => `נמחקו בהצלחה ${deleted} משתמשים.`,
        noDeletedMessage: (key) => `לא נמחקו משתמשים.`,

        skippedExplanationTitle: 'למה משתמשים לא נמחקו?',
        skippedExplanation: 'המשתמשים הבאים לא נמחקו מכיוון שהם מנהלי ארגון. כדי למחוק אותם, יש להסיר תחילה את הרשאות המנהל שלהם מכל הארגונים הרלוונטיים.',

        skipReason: 'סיבה',
        reasons: {
            orgAdmin: 'מנהל ארגון',
            adminOf: 'מנהל של',
            self: 'לא ניתן למחוק את עצמך',
            notFound: 'משתמש לא נמצא',
            // Deletion protection reasons from backend
            cannot_delete_self: 'לא ניתן למחוק את עצמך',
            cannot_delete_superadmin: 'לא ניתן למחוק סופר אדמין',
            cannot_delete_company_admin: 'לא ניתן למחוק מנהל חברה',
            cannot_delete_organizational_admin: 'לא ניתן למחוק מנהל ארגון',
            different_company: 'המשתמש שייך לחברה אחרת',
            not_an_organizational_admin: 'אינך מנהל ארגון',
            not_admin_of_all_user_organizations: 'אינך מנהל של כל הארגונים של המשתמש',
            generic_error: 'לא ניתן למחוק את המשתמש'
        }
    },
    SARemoveUser: {
        permanentlyDeleteUser: 'מחיקה לצמיתות',
        deleteUserTitle: 'מחיקת משתמש לצמיתות',
        deleteUserText: 'האם אתה/את בטוח/ה שברצונך למחוק לצמיתות את המשתמש',
        deleteOrgConfirm: 'מחק משתמש לצמיתות',
    },
    SADeleteUsersPermanentlyModal: {
        title: 'מחיקה לצמיתות של משתמשים',
        firstName: 'שם פרטי',
        lastName: 'שם משפחה',
        email: 'אימייל',
        phone: 'טלפון',
        employeeID: 'מזהה עובד',
        idNumber: 'תעודת זהות',
        organizations: 'יחידות ארגוניות',
        identifier: 'מזהה',
        warningTitle: 'אזהרה! פעולה בלתי הפיכה',
        warningMessage: (key, {userCount}) => `אתה עומד למחוק לצמיתות ${userCount} משתמשים. פעולה זו לא ניתנת לביטול ותסיר לצמיתות את המשתמשים מבסיס הנתונים.`,
        confirmationRequired: 'על מנת לאשר, הקלד את הטקסט הבא:',
        confirmationText: 'מחק לצמיתות',
        confirmationPlaceholder: 'הקלד "מחק לצמיתות" כדי לאשר',
        deleteUsersPermanently: 'מחק משתמשים לצמיתות',
        cancel: 'ביטול',
        fetchError: 'שגיאה בטעינת נתוני משתמשים',
        deleteError: 'שגיאה במחיקת משתמשים לצמיתות',
        deleting: 'מוחק לצמיתות...',
        confirmationMismatch: 'הטקסט שהוקלד אינו תואם. נא להקליד "מחק לצמיתות" בדיוק.',
    },
    SARestoreUser: {
        restoreUsers: 'שחזר משתמשים',
        restoreUsersTitle: 'שחזור משתמשים',
        restoreUsersText: (key, {userCount}) => `האם אתה בטוח שברצונך לשחזר ${userCount} משתמשים?`,
        restoreUsersConfirm: 'כן, שחזר משתמשים',
    },
    automations: {
        title: 'אוטומציות',
        subTitle: 'ניהול והגדרות',
        addAutomation: 'הוספת אוטומציה',
        editAutomation: 'עריכת אוטומציה',
        deleteAutomation: 'מחיקת אוטומציה',
        automationName: 'שם האוטומציה',
        automationDescription: 'תיאור האוטומציה',
        automationImage: 'תמונת האוטומציה',
        automationCard: {
            editAutomation: 'עריכת אוטומציה',
        },
        notifications: {
            title: 'יצירת אוטומציה',
            subTitle: 'לתזמון תזכורות',
        },
        createAutomationModal: {
            title: 'יצירת אוטומציה חדשה',
            weWillSendNotificationTo: 'נתזכר את כל מי שלא סיים את לומדה ',
            allOrganizations: 'כל היחידות הארגוניות',
            allCourses: 'כל המשימות',
            automationKind: {
                signDoc: 'תזכורות משימות',
                course: 'תזכורות קורסים',
                signDocDescription: 'תזכורות עבור מסמכים לחתימה, סרטונים, אודיו ומשימות אחרות',
                courseDescription: 'תזכורות עבור קורסים רגילים וחומרי לימוד'
            },
            organizationOptions: {
                label: 'איזו יחידה ארגונית?',
                pleaseSelect: 'אנא בחרו את היחידה הארגונית שברצונך לשלוח תזכורת עבורה',
                error: 'יש לבחור יחידה ארגונית לשליחת התזכורת'
            },
            taskOptions: {
                label: 'איזו משימה?',
                signDocLabel: 'איזו משימה?',
                courseLabel: 'איזה קורס?',
                pleaseSelect: 'אנא בחרו את המשימה שברצונכם לשלוח תזכורת עבורה',
                error: 'יש לבחור לומדה לשליחת התזכורת'
            },
            selectHourLabel: 'באיזו שעה?',
            selectHourError: 'יש לבחור שעה לשליחת התזכורת',
            howManyDaysBefore: 'כמה ימים לפני?',
            howManyDaysBeforeError: 'יש לבחור כמה ימים לפני תרצו לשלוח את התזכורת',
            daysBeforeError: 'יש לבחור מספר ימים תקין בין 1 ל-50',
            nameLabel: 'שם האוטומציה',
            nameError: 'יש להזין שם לאוטומציה',
            descriptionLabel: 'תיאור האוטומציה',
            create: 'צור אוטומציה',
            automationType: {
                label: 'סוג האוטומציה',
                oneTime: 'תזכורת חד פעמית',
                recurring: 'תזכורות חוזרות'
            },
            recurring: {
                frequency: 'תדירות',
                every: 'כל',
                startDate: 'תאריך התחלה',
                endDate: 'תאריך סיום (אופציונלי)',
                unlimited: 'ללא הגבלה',
                runHour: 'שעת ביצוע',
                preview: 'תצוגה מקדימה',
                startDateRequired: 'יש להזין תאריך התחלה',
                startDatePast: 'תאריך ההתחלה לא יכול להיות בעבר',
                endDateInvalid: 'תאריך הסיום חייב להיות אחרי תאריך ההתחלה',
                maxRunsRequired: 'יש להזין מספר ביצועים מקסימלי',
                runHourRequired: 'יש לבחור שעת ביצוע',
                daily: 'יומי',
                weekly: 'שבועי',
                monthly: 'חודשי',
                dailySingle: 'יום',
                dailyPlural: 'ימים',
                weeklySingle: 'שבוע',
                weeklyPlural: 'שבועות',
                monthlySingle: 'חודש',
                monthlyPlural: 'חודשים',
            },
            modalRecurringPreview: (key, {frequencyText, runHour}) => `התזכורות יצאו כל ${frequencyText} בשעה ${runHour}`
        }
    },
    automationsTable: {
        columns: {
            automationName: 'שם האוטומציה',
            automationType: 'סוג אוטומציה',
            description: 'תיאור האוטומציה',
            organization: 'יחידות ארגוניות',
            task: 'משימות',
            when: 'מתי?',
            progress: 'התקדמות',
            status: 'סטטוס',
            how: 'איך שולחים?',
            delete: 'מחיקה',
            edit: 'עריכה',
            details: 'פרטים',
        },

        status: {
            SCHEDULED: 'תוזמן',
            COMPLETED: 'הושלם',
            PAUSED: 'מושהה',
            CANCELLED: 'בוטל',
            sentAndNotSent: (key, {sent, notSent}) => `נשלחו ${sent} ולא נשלחו ${notSent}`,
        },
        sendType: {
            SMS: 'הודעת טקסט',
            EMAIL: 'אימייל',
            WHATSAPP: 'וואטסאפ',
        },
        atHour: 'בשעה',
        daysBefore: 'ימים לפני תאריך סיום הלומדה',
        automationRuns: {
            title: 'היסטוריית ביצועים',
            columns: {
                runNumber: 'ביצוע מס׳',
                scheduledTime: 'זמן מתוכנן',
                actualTime: 'זמן ביצוע בפועל',
                status: 'סטטוס',
                usersProcessed: 'משתמשים שנבדקו',
                messagesSent: 'הודעות נשלחו',
                messagesFailed: 'הודעות נכשלו',
                successRate: 'אחוז הצלחה',
                details: 'פרטים'
            },
            runStatuses: {
                SCHEDULED: 'מתוכנן',
                RUNNING: 'רץ כעת',
                COMPLETED: 'הושלם',
                FAILED: 'נכשל',
                SKIPPED: 'דולג'
            }
        },
        nextRun: 'הביצוע הבא',
        lastRun: 'הביצוע האחרון',
        totalRuns: 'סה״כ ביצועים',
        automationTypeBadge: {
            oneTime: 'לפני תאריך סיום',
            recurring: 'חוזר'
        }
    },
    allOrganizations: 'כל היחידות הארגוניות',
    allSignDocs: 'כל המשימות',
    organizationIntersectionFilter: {
        label: 'צומת יחידה ארגונית',
        tooltip: 'סימן חיתוך - מתאר חיתוך בין שתי קבוצות כאשר התוצאה המתקבלת היא קבוצת המשתמשים שנמצאים בשתי הקבוצות'
    },
    confirmationModal: {
        confirm: 'אישור',
        cancel: 'ביטול',
    },
    deleteAutomationModal: {
        title: 'מחיקת אוטומציה',
        message: 'האם את/ה בטוח/ה שברצונך למחוק את האוטומציה?',
        deleteAutomation: 'מחק אוטומציה',
        automationName: 'שם האוטומציה',
    },
    newDocSign: {
        buttonTitle: 'יצירת משימה חדשה',
        modal: {
            title: 'יצירת משימה חדשה',
            newVersionTitle: 'יצירת גרסה חדשה',
            editSignDocTitle: 'עריכת משימה',
            docNameLabel: {
                'REGULAR_COURSE': 'שם הקורס',
                'READ_AND_SIGN_DOC_PDF': 'שם המסמך',
                'WATCH_AND_SIGN_YOUTUBE_LINK': 'שם הסרטון',
                'WATCH_AND_SIGN_VIMEO_LINK': 'שם הסרטון',
                'WATCH_AND_SIGN_VIDEO_FILE': 'שם הסרטון',
                'CANVA_PRESENTATION': 'שם המצגת',
                'EXAM': 'שם המבחן',
                'LEARNING_PATH': 'שם מסלול ההכשרה',
                'PODCAST': 'שם הפודקאסט',
                'AUDIO_FILE': 'שם קובץ השמע',
                'FRONTAL_COURSE': 'שם ההרצאה הפרונטלית',
                'ONLINE_COURSE': 'שם הקורס המקוון',
                'PRESENTATION': 'שם המצגת',
                'ARTICLE': 'שם המאמר',
                'SURVEY': 'שם הסקר',
                'LINK': 'שם הקישור',
                'UPLOAD_DOCUMENT': 'שם המשימה',
            },
            docDescriptionLabel: {
                'REGULAR_COURSE': 'תיאור המסמך',
                'READ_AND_SIGN_DOC_PDF': 'תיאור המסמך',
                'WATCH_AND_SIGN_YOUTUBE_LINK': 'תיאור הסרטון',
                'WATCH_AND_SIGN_VIMEO_LINK': 'תיאור הסרטון',
                'WATCH_AND_SIGN_VIDEO_FILE': 'תיאור הסרטון',
                'CANVA_PRESENTATION': 'תיאור המצגת',
                'EXAM': 'תיאור המבחן',
                'LEARNING_PATH': 'תיאור מסלול ההכשרה',
                'PODCAST': 'תיאור הפודקאסט',
                'AUDIO_FILE': 'תיאור קובץ השמע',
                'FRONTAL_COURSE': 'תיאור ההרצאה הפרונטלית',
                'ONLINE_COURSE': 'תיאור הקורס המקוון',
                'PRESENTATION': 'תיאור המצגת',
                'ARTICLE': 'תיאור המאמר',
                'SURVEY': 'תיאור הסקר',
                'LINK': 'תיאור הקישור',
                'UPLOAD_DOCUMENT': 'תיאור המשימה',
            },
            createButtonText: {
                'REGULAR_COURSE': 'צור לומדה',
                'READ_AND_SIGN_DOC_PDF': 'צור מסמך',
                'WATCH_AND_SIGN_YOUTUBE_LINK': 'צור משימת צפייה',
                'WATCH_AND_SIGN_VIMEO_LINK': 'צור משימת צפייה',
                'WATCH_AND_SIGN_VIDEO_FILE': 'צור משימת צפייה',
                'AUDIO_FILE': 'צור משימת האזנה',
                'CANVA_PRESENTATION': 'צור מצגת',
                'EXAM': 'צור מבחן',
                'LEARNING_PATH': 'צור מסלול הכשרה',
                'PODCAST': 'צור פודקאסט',
                'FRONTAL_COURSE': 'צור הרצאה פרונטלית',
                'ONLINE_COURSE': 'צור קורס מקוון',
                'PRESENTATION': 'צור מצגת',
                'ARTICLE': 'צור מאמר',
                'SURVEY': 'צור סקר',
                'LINK': 'צור קישור',
                'UPLOAD_DOCUMENT': 'צור משימת העלאה',
            },
            dropDocLabel: {
                'READ_AND_SIGN_DOC_PDF': 'גרור קובץ PDF לכאן או לחץ לבחירת קובץ',
                'WATCH_AND_SIGN_VIDEO_FILE': 'גרור קובץ וידאו לכאן או לחץ לבחירת קובץ',
                'AUDIO_FILE': 'גרור קובץ שמע לכאן או לחץ לבחירת קובץ',
                'UPLOAD_DOCUMENT': 'גרור קובץ לכאן או לחץ לבחירת קובץ',
            },
            examExtraSaveButton: 'שמור והמשך לעריכת השאלות',
            weezBeeCourseExtraSaveButton: 'שמור והמשך לעריכת הקורס',
            learningPathExtraSaveButton: 'שמור והמשך לעריכת מסלול ההכשרה',
            surveyExtraSaveButton: 'שמור והמשך לעריכת הסקר',
            createDocument: 'צור מסמך',
            createExam: 'צור מבחן',
            createLearningPath: 'צור מסלול הכשרה',
            dropSignDocHere: 'גרור קובץ של מסמך לכאן או לחץ לבחירת קובץ',
            selectSignDocType: 'סוג',
            linkUrl: 'קישור',
            youtubeLinkNotAllowed: 'לא ניתן להזין קישור ל Youtube',
            vimeoLinkNotAllowed: 'לא ניתן להזין קישור ל Vimeo',
            canvaLinkNotAllowed: 'לא ניתן להזין קישור ל Canva',
            invalidLink: "קישור לא תקין",
            notifyUsersOfNewTask: 'שלח הודעה למשתמשים לגבי משימה חדשה',
            notifyUsersOfNewTaskTooltip: 'ההודעה תישלח רק למשתמשים שעדיין לא קיבלו הודעת התנעה על משימה זו',
            quotaWarning: {
                title: 'אין מספיק יתרת הודעות',
                message: (key, { quotaNeeded, quotaAvailable, totalUsers }) => `נדרשות ${quotaNeeded} הודעות לשליחה ל-${totalUsers} משתמשים, אבל רק ${quotaAvailable} הודעות זמינות.`,
                contactSupport: 'אנא פנו לתמיכה לרכישת חבילת הודעות נוספת, או כבו את שליחת ההודעות כדי לשמור ללא שליחת התראות.',
                disableNotificationToSave: 'כבו את ההתראות כדי לשמור את המסמך',
            },
            forceCompletion: 'נדרש לבצע',
            nonForceCompletion: 'מרכז הידע',
            noDate: 'ללא תאריך סיום',
            isMustDo: {
                label: 'חובה לעמידה בדרישות',
                tooltip: 'משתמשים חייבים להשלים משימה זו כדי לעבור את בדיקת העמידה בדרישות החיצונית'
            },
            allowFastForward: {
                WATCH_AND_SIGN_VIDEO_FILE: 'אפשר להריץ קדימה בסרטון',
                WATCH_AND_SIGN_YOUTUBE_LINK: 'אפשר להריץ קדימה בסרטון',
                WATCH_AND_SIGN_VIMEO_LINK: 'אפשר להריץ קדימה בסרטון',
                AUDIO_FILE: 'אפשר להריץ קדימה בקובץ שמע',
            },
            organizationAssignmentInfo: 'ניתן יהיה לשייך את המשימה ליחידות ארגוניות בעת עריכת המשימה',
            assignToAllOrganizations: 'שייך לכל היחידות הארגוניות',
            removeFromAllOrganizations: 'הסר מכל היחידות הארגוניות',
            assignmentTabs: {
                organizations: 'הקצאה ליחידות ארגוניות',
                individualUsers: 'הקצאה אישית למשתמשים'
            },
            assignmentSubTabs: {
                allUsers: 'כל המשתמשים',
                selected: 'נבחרו',
                noSelectedUsers: 'לא נבחרו משתמשים'
            },
            recurring: {
                toggleLabel: 'הפעל מחזוריות',
                toggleDescription: 'צור גרסאות חדשות באופן אוטומטי במרווחי זמן קבועים',
                frequencyLabel: 'מחזוריות',
                frequencyNote: 'משתמשים יוקצו מחדש לגרסאות חדשות לפי לוח זמנים זה',
                nextVersionDate: 'גרסה הבאה תיווצר בתאריך',
                minimumFrequencyError: 'מחזוריות מינימלית היא חודש אחד',
                nextVersionDateLabel: 'תאריך הגרסה הבאה',
                transitionDisclaimer: 'משימה זו עוברת ממשימה רגילה למשימה מחזורית. נדרש לבחור תאריך לגרסה הבאה. תאריך זה ייאכף על כל המשתמשים המשויכים. לאחר תאריך זה, גרסאות חדשות ייווצרו באופן אוטומטי לפי התדירות שנבחרה. ניתן לערוך את התאריך בכל עת מעמוד ניהול הגרסאות.',
            },
            groupType: {
                label: 'תדירות',
                SEQUENTIAL: 'מחזורית',
                PARALLEL: 'ללא תדירות'
            },
            status: {
                label: 'סטטוס',
                ACTIVE: 'פעילה',
                ARCHIVED: 'בארכיון'
            }
        },
    },
    signDocModal: {
        importUsers: {
            modalTitle: 'ייבוא משתמשים מקובץ',
            importFromFile: 'ייבוא מקובץ',
            matchedUsers: 'משתמשים תואמים',
            unmatchedRows: 'שורות ללא התאמה',
            addUsers: (key, {count}) => `הוסף ${count} משתמשים`,
            noMatchesFound: 'לא נמצאו משתמשים תואמים',
            unmatchedRowsHint: 'שורות אלו לא תאמו לאף משתמש במערכת. בדוק שמספרי הטלפון תואמים.',
            processingFile: 'מעבד קובץ...',
            fileError: 'שגיאה בקריאת הקובץ'
        }
    },
    signDocProgress: {
        notStarted: {
            READ_AND_SIGN_DOC_PDF: 'לא קראתי',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'לא צפיתי',
            WATCH_AND_SIGN_VIMEO_LINK: 'לא צפיתי',
            WATCH_AND_SIGN_VIDEO_FILE: 'לא צפיתי',
            AUDIO_FILE: 'לא האזנתי',
            REGULAR_COURSE: 'לא התחלתי',
            CANVA_PRESENTATION: 'לא צפיתי',
            EXAM: 'לא התחלתי',
            LEARNING_PATH: 'לא התחלתי',
            LINK: 'לא צפיתי',
            SURVEY: 'לא התחלתי',
            WEEZBEE_COURSE: 'לא התחלתי',
            UPLOAD_DOCUMENT: 'לא העליתי',
            FRONTAL_COURSE: 'לא התחלתי',
            ONLINE_COURSE: 'לא התחלתי',
        },
        inProgress: {
            READ_AND_SIGN_DOC_PDF: 'קראתי',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'התחלתי',
            WATCH_AND_SIGN_VIMEO_LINK: 'התחלתי',
            WATCH_AND_SIGN_VIDEO_FILE: 'התחלתי',
            AUDIO_FILE: 'האזנתי',
            REGULAR_COURSE: 'התחלתי',
            CANVA_PRESENTATION: 'צפיתי',
            EXAM: 'התחלתי',
            LEARNING_PATH: 'התחלתי',
            LINK: 'ביקרתי',
            SURVEY: 'התחלתי',
            WEEZBEE_COURSE: 'התחלתי',
            UPLOAD_DOCUMENT: 'העלאתי',
            FRONTAL_COURSE: 'רשומ/ה',
            ONLINE_COURSE: 'רשומ/ה',
        },
        finished: {
            READ_AND_SIGN_DOC_PDF: 'חתמתי!',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'סיימתי!',
            WATCH_AND_SIGN_VIMEO_LINK: 'סיימתי!',
            WATCH_AND_SIGN_VIDEO_FILE: 'סיימתי!',
            AUDIO_FILE: 'סיימתי!',
            REGULAR_COURSE: 'סיימתי!',
            CANVA_PRESENTATION: 'חתמתי!',
            EXAM: 'סיימתי!',
            LEARNING_PATH: 'סיימתי!',
            LINK: 'קראתי!',
            SURVEY: 'סיימתי!',
            WEEZBEE_COURSE: 'סיימתי!',
            UPLOAD_DOCUMENT: 'אושר',
            FRONTAL_COURSE: 'סיימתי!',
            ONLINE_COURSE: 'סיימתי!',
        }
    },
    signDocProgressMgmnt: {
        notStarted: 'לא נפתח',
        inProgress: 'נפתח',
        finished: 'חתום',
        opened: 'נפתח'
    },
    signDocPage: {
        title: {
            read: {
                sign: 'אישור קריאת מסמך',
                noSign: 'קריאת מסמך',
                knowledgeOnly: 'קריאת מסמך'
            },
            watch: {
                sign: 'צפייה בסרטון',
                noSign: 'צפייה בסרטון',
                knowledgeOnly: 'צפייה בסרטון'
            },
            listen: {
                sign: 'אישור האזנה לקובץ שמע',
                noSign: 'האזנה לקובץ שמע',
                knowledgeOnly: 'האזנה לקובץ שמע'
            },
            link: {
                sign: 'אישור צפייה בלינק'
            },
            upload: {
                sign: 'העלאת מסמך',
                noSign: 'צפייה במסמך שהועלה',
                knowledgeOnly: 'העלאת מסמך'
            },
            canva: {
                sign: 'אישור צפייה במצגת',
                noSign: 'צפייה במצגת',
                knowledgeOnly: 'צפייה במצגת'
            }
        },
        subTitle: {
            read: {
                sign: 'אשרו וחתמו כי קראתם את המסמך',
                noSign: 'קריאה חוזרת לאחר חתימה',
            },
            watch: {
                sign: '',
                noSign: 'צפייה חוזרת',
            },
            listen: {
                sign: '',
                noSign: 'האזנה חוזרת',
            },
            link: {
                sign: 'אשרו וחתמו כי צפיתם בתוכן הלינק'
            },
            upload: {
                sign: 'העלו את המסמך הנדרש',
                noSign: 'המסמך הועלה בהצלחה'
            },
            canva: {
                sign: 'עברו על כל המצגת וחתמו לאישור',
                noSign: 'צפייה חוזרת לאחר חתימה'
            }
        },
        signatureTitle: {
            read : 'חתמו בכדי לאשר כי קראתם את המסמך',
            watch: 'חתמו בכדי לאשר כי צפיתם בסרטון',
            listen: 'חתמו בכדי לאשר כי האזנתם לקובץ השמע',
            link: 'חתמו בכדי לאשר כי ביקרתם בקישור',
            canva: 'חתום כדי לאשר שעברת על כל המצגת',
        },
        signatureSubtitle: {
            read: 'על מנת לאשר את קריאת המסמך חתמו כאן',
            watch: 'על מנת לאשר את הצפיה המסמך חתמו כאן',
            listen: 'על מנת לאשר את ההאזנה לקובץ השמע חתמו כאן',
            link: 'על מנת לאשר את הביקור בקישור חתמו כאן',
            canva: 'על מנת לאשר שסיימת את המצגת חתמו כאן',
        },
        signatureSubtitleNotCompleted: {
            read: 'לאחר הקריאה יופיעו משטח לחתימה וכפתור לאישר',
            watch: 'לאחר הצפיה יופיעו משטח לחתימה וכפתור לאישר',
            listen: 'לאחר ההאזנה יופיעו משטח לחתימה וכפתור לאישר',
            canva: 'לאחר סיום המצגת יופיעו משטח לחתימה וכפתור לאישר',
        },
        iApproveReadingTheDoc: {
            read: 'קראתי את המסמך!',
            watch: 'צפיתי בסרטון!',
            listen: 'האזנתי לקובץ השמע!',
            link: 'ביקרתי בקישור!',
            canva: 'סיימתי את המצגת!',
        },
        clear: 'נקה חתימה',
        uploadDocument: {
            title: 'העלאת מסמך',
            subtitle: 'אנא העלו את המסמך הנדרש',
            completed: 'המסמך אושר בהצלחה',
            completedMessage: 'תודה! המסמך שלכם אושר בהצלחה על ידי המנהל.',
            uploaded: 'המסמך הועלה בהצלחה',
            waitingApproval: 'המסמך ממתין לאישור מנהל',
            uploadedFile: 'מסמך שהועלה',
            fileSize: 'גודל קובץ',
            stepUploaded: 'הועלה',
            replaceFile: 'גרור קובץ חדש או לחץ להחלפה',
            uploadedFiles: 'קבצים שהועלו',
            saveButton: 'שמירה וחזרה לדף הבית',
            rejectionTitle: 'המסמך שהעלתם נדחה',
            rejectionReasonLabel: 'סיבת הדחייה',
            rejectedBy: 'נדחה על ידי',
            rejectionNoReason: 'המנהל דחה את המסמך ללא ציון סיבה.',
            rejectionAction: 'אנא העלו מסמך חדש בהתאם להנחיות.',
            successModal: {
                title: 'המסמך נשמר בהצלחה!',
                message: 'המסמך שלך הועלה בהצלחה וממתין לאישור המנהל.',
            },
            enableApprovals: {
                toggleLabel: 'דרישת אישור עבור העלאות',
                enabledNote: 'כאשר מופעל, מנהלים חייבים לאשר את הקבצים שהועלו על ידי משתמשים לפני שהמשימה מסומנת כהושלמה.',
                disabledNote: 'כאשר כבוי, קבצים שהועלו על ידי משתמשים יאושרו אוטומטית והמשימה תסומן כהושלמה מיידית.'
            }
        },
        courseAttendanceApprovals: {
            sectionTitle: 'מאשרי נוכחות',
            description: 'בחר משתמשים ספציפיים שיוכלו לסמן נוכחות עבור קורס זה. אם לא תבחר, רק מנהלי החברה או את/ה תוכלו לסמן נוכחות.',
            userLabel: 'בחר משתמשים כמאשרי נוכחות',
        }
    },
    filePreview: {
        noPreviewAvailable: 'אין תצוגה מקדימה זמינה',
        notAvailable: 'תצוגה מקדימה אינה זמינה לסוג קובץ זה',
        downloadToView: 'הורד קובץ לצפייה'
    },
    signDocCard: {
        rejected: 'נדחה',
        rejectedMessage: 'המסמך שלך נדחה',
        uploadAgain: 'העלה שוב',
        noDateSet: 'לא נקבע תאריך',
        youAreDone: {
            READ_AND_SIGN_DOC_PDF: 'חתמת על המסמך',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'צפית בסרטון',
            WATCH_AND_SIGN_VIMEO_LINK: 'צפית בסרטון',
            WATCH_AND_SIGN_VIDEO_FILE: 'צפית בסרטון',
            AUDIO_FILE: 'האזנת לקובץ השמע',
            REGULAR_COURSE: 'סיימת את הלומדה',
            CANVA_PRESENTATION: 'צפית במצגת',
            EXAM: 'סיימת את המבחן',
            WEEZBEE_COURSE: 'סיימת את הקורס',
            LEARNING_PATH: 'סיימת את ההכשרה',
            LINK: 'צפית בקישור',
            SURVEY: 'סיימת את הסקר',
            UPLOAD_DOCUMENT: 'העלית את המסמך',
            FRONTAL_COURSE: 'השתתפת בהרצאה',
            ONLINE_COURSE: 'סיימת את הקורס המקוון',
        },
        finishBy: {
            READ_AND_SIGN_DOC_PDF: (key, {finishByDate}) => `יש לחתום עד ל  ${finishByDate}`,
            WATCH_AND_SIGN_YOUTUBE_LINK: (key, {finishByDate}) => `יש לצפות עד ל  ${finishByDate}`,
            WATCH_AND_SIGN_VIMEO_LINK: (key, {finishByDate}) => `יש לצפות עד ל  ${finishByDate}`,
            WATCH_AND_SIGN_VIDEO_FILE: (key, {finishByDate}) => `יש לצפות עד ל  ${finishByDate}`,
            AUDIO_FILE: (key, {finishByDate}) => `יש להאזין עד ל  ${finishByDate}`,
            REGULAR_COURSE: (key, {finishByDate}) => `יש לסיים עד ל  ${finishByDate}`,
            CANVA_PRESENTATION: (key, {finishByDate}) => `יש לצפות עד ל  ${finishByDate}`,
            EXAM: (key, {finishByDate}) => `יש לסיים עד ל  ${finishByDate}`,
            WEEZBEE_COURSE: (key, {finishByDate}) => `יש לסיים עד ל  ${finishByDate}`,
            LEARNING_PATH: (key, {finishByDate}) => `יש לסיים עד ל  ${finishByDate}`,
            LINK: (key, {finishByDate}) => `יש לבקר עד ל  ${finishByDate}`,
            SURVEY: (key, {finishByDate}) => `יש לסיים עד ל  ${finishByDate}`,
            UPLOAD_DOCUMENT: (key, {finishByDate}) => `יש להעלות עד ל  ${finishByDate}`,
            FRONTAL_COURSE: (key, {finishByDate}) => `הרצאה בתאריך: ${finishByDate}`,
            ONLINE_COURSE: (key, {finishByDate}) => `קורס מקוון בתאריך: ${finishByDate}`,
        },
        youAreDoneWatchAgain: {
            READ_AND_SIGN_DOC_PDF: 'קרא שוב',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'צפה שוב',
            WATCH_AND_SIGN_VIMEO_LINK: 'צפה שוב',
            WATCH_AND_SIGN_VIDEO_FILE: 'צפה שוב',
            AUDIO_FILE: 'האזן שוב',
            REGULAR_COURSE: 'צפה שוב',
            CANVA_PRESENTATION: 'צפה שוב',
            EXAM: 'מעבר על המבחן',
            WEEZBEE_COURSE: 'צפה שוב',
            LEARNING_PATH: 'מעבר על ההכשרה',
            LINK: 'צפה שוב',
            SURVEY: 'מעבר על הסקר',
            UPLOAD_DOCUMENT: 'צפה שוב במשימה',
            FRONTAL_COURSE: 'צפה בפרטים שוב',
            ONLINE_COURSE: 'צפה שוב',
        },
        goToCourse: {
            READ_AND_SIGN_DOC_PDF: 'מעבר לקריאה',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'מעבר לצפייה',
            WATCH_AND_SIGN_VIMEO_LINK: 'מעבר לצפייה',
            WATCH_AND_SIGN_VIDEO_FILE: 'מעבר לצפייה',
            AUDIO_FILE: 'מעבר להאזנה',
            REGULAR_COURSE: 'מעבר ללומדה',
            CANVA_PRESENTATION: 'מעבר לצפייה',
            EXAM: 'מעבר למבחן',
            WEEZBEE_COURSE: 'מעבר לקורס',
            LEARNING_PATH: 'מעבר למסלול',
            LINK: 'מעבר לקישור',
            SURVEY: 'מעבר לסקר',
            UPLOAD_DOCUMENT: 'מעבר לעמוד ההעלאה',
            FRONTAL_COURSE: 'ביצוע יאושר על ידי מנהל/ת',
            ONLINE_COURSE: 'מעבר לקורס',
        },
        disabledButtonTooltips: {
            locked: 'המשימה נעולה ואינה זמינה כעת',
            surveyNotRedoable: 'הסקר אנונימי וכבר בוצע ולכן לא ניתן לבצעו שוב',
            genericNotRedoable: 'המשימה כבר בוצעה ולא ניתן לבצעה שוב',
            frontalCourseDisabled: 'נוכחות בהרצאה פרונטלית מסומנת על ידי המנהל/ת בלבד'
        },
        examScore: (key, { score }) => `ציון: ${score}`,
        completedByAdmin: 'הושלם ע״י מנהל',
    },
    Errors_409: {
        storage_quota_error: (key, {bytesCompanyStorageQuota, bytesCompanyUsedStorage, bytesNewUsedStorage}) => {
            const leftQuotaMB = '\u200E' + ((bytesCompanyStorageQuota - bytesCompanyUsedStorage) / (1024 * 1024)).toFixed(2) + ' MB'
            const bytesNewUsedStorageMB = (bytesNewUsedStorage / (1024 * 1024)).toFixed(2) + ' MB'
            const bytesCompanyStorageQuotaMB = (bytesCompanyStorageQuota / (1024 * 1024)).toFixed(2) + ' MB'
            return `אין מספיק מקום אחסון זמין, נסו למחוק קבצים או לפנות למנהל המערכת. נשארו לכם ${leftQuotaMB} מתוך ${bytesCompanyStorageQuotaMB} זמינים, והקובץ שאתה מנסה להעלות גודלו ${bytesNewUsedStorageMB}`
        },
        missing_company_organization: 'עלייך לבחור למשתמש יחידה ארגונית',
        user_already_received_welcome_message: 'המשתמש כבר קיבל הודעת ברוך הבא',
        company_has_no_sms_quota: 'אין לחברה מספיק קרדיטי הודעות זמינים, אנא צור קשר עם שירות לקוחות על מנת לרכוש חבילת הודעות',
        original_password_dont_match: 'הסיסמא שסופקה שגויה',
        password_too_weak: 'הסיסמא לא חזקה מספיק',
        organization_still_has_users: 'יש עדיין משתמשים בארגון שצריכים להימחק או לשייך לארגון אחר',
        total_points_exceed_100: 'סכום הניקוד של כל השאלות לא יכול לעלות על 100',
        user_not_found: 'משתמש/ת לא נמצא, אנא בדקו אם המייל או מספר הפלאפון שסופק נכון. אם עדיין המשתמש/ת לא נמצא, נא לפנות למנהל/ת המערכת'
    },
    signDocTypes: {
        READ_AND_SIGN_DOC_PDF: 'מסמך PDF לחתימה',
        WATCH_AND_SIGN_YOUTUBE_LINK: 'קישור Youtube לצפייה',
        WATCH_AND_SIGN_VIMEO_LINK: 'קישור VIMEO לצפייה',
        WATCH_AND_SIGN_VIDEO_FILE: 'קובץ וידאו לצפייה',
        REGULAR_COURSE: 'קורס',
        CANVA_PRESENTATION: 'מצגת Canva לצפייה',
        EXAM: 'מבחן',
        WEEZBEE_COURSE: 'קורס ויזבי',
        LEARNING_PATH: 'מסלול הכשרה',
        AUDIO_FILE: 'קובץ שמע',
        LINK: 'קישור',
        SURVEY: 'סקר',
        UPLOAD_DOCUMENT: 'מסמך להעלאה',
        FRONTAL_COURSE: 'הדרכה פרונטלית',
        ONLINE_COURSE: 'הדרכה אונליין',
    },
    signDocTypesNotForCompletion: {
        READ_AND_SIGN_DOC_PDF: 'מסמך PDF',
        WATCH_AND_SIGN_YOUTUBE_LINK: 'לינק יוטיוב לצפיה',
        WATCH_AND_SIGN_VIMEO_LINK: 'לינק VIMEO לצפיה',
        WATCH_AND_SIGN_VIDEO_FILE: 'קובץ וידאו לצפיה',
        REGULAR_COURSE: 'לומדה',
        CANVA_PRESENTATION: 'מצגת Canva',
        EXAM: 'מבחן',
        WEEZBEE_COURSE: 'קורס ויזבי',
        LEARNING_PATH: 'מסלול הכשרה',
        AUDIO_FILE: 'קובץ שמע',
        LINK: 'קישור',
        SURVEY: 'סקר',
        UPLOAD_DOCUMENT: 'משימת העלאה',
        FRONTAL_COURSE: 'הדרכה פרונטלית',
        ONLINE_COURSE: 'הדרכה אונליין',
    },
    managementCourseList: {
        signDocButtonTitle: 'יצירת משימת צפיה'
    },
    isCompanyAdmin: {
        makeAdmin: {
            title: 'הגדרה כמנהל/ת חברה',
            message: 'האם אתם בטוחים שברצונכם להגדיר את המשתמש כמנהל/ת חברה?',
            confirm: 'הגדרה כמנהל/ת חברה',
            button: 'הגדר כמנהל/ת חברה',
        },
        removeAdmin: {
            title: 'הסרת מנהל/ת חברה',
            message: 'האם אתה בטוחים שברצונכם להסיר את המשתמש מהתפקיד של מנהל/ת חברה?',
            confirm: 'הסרה כמנהל/ת חברה',
            button: 'הסר כמנהל/ת חברה',
        },
        userName: 'שם משתמש',
    },
    general: {
        saveChanges: 'שמור שינויים',
        close: 'סגור',
        cancel: 'ביטול',
        save: 'שמור',
        deleteConfirm: 'לבצע את המחיקה?',
        delete: 'מחיקה',
        areYouSure: 'האם אתם בטוחים?',
        copyOf: 'עותק של',
        duplicating: 'משכפל...',
        next: 'הבא',
        back: 'חזרה',
        create: 'יצירה',
    },
    knowledgeCenter: {
        title: 'מרכז הידע',
        subTitle: 'כל המידע במקום אחד',
    },
    operation: {
        title: 'טפסים ומידע',
        subTitle: 'כל משימות התפעול במקום אחד',
    },
    adminUsersTable: {
        columns: {
            fullName: 'שם מלא',
            firstName: 'שם פרטי',
            lastName: 'שם משפחה',
            email: 'אימייל',
            phone: 'טלפון',
            roles: 'תפקידים',
            managerOfOrganizations: 'מנהל/ת ביחידות ארגוניות',
            id: 'מזהה',
            edit: 'עריכה',
            isCompanyAdmin: 'מנהל/ת חברה',
            isCompanyAdminYes: 'כן',
            isCompanyAdminNo: 'לא',
        },
        addAdminUser: 'הוספת מנהל/ת',
    },
    editAdminUserModal: {
        title: 'שיוך מנהל/ת',
        titleEdit: 'עריכת מנהל/ת',
        sendWelcomeMessage: 'שליחת הודעת חיבור ראשוני למנהל/ת',
        save: 'שמור שינויים',
        selectOrganizationalUnits: 'בחר/י יחידות ארגוניות',
        searchUser: 'חיפוש משתמש',
        isCompanyAdmin: 'מנהל/ת חברה',
        companyAdminWillBeAdminOfAllOrgs: 'מנהל/ת החברה יגדרו כמנהלים בכל היחידות הארגוניות',
        selectAllOrgs: 'בחר/י את כל היחידות הארגוניות',
    },
    autoComplete: {
        search: 'חיפוש',
        selectAll: 'בחר/י הכל',
        noOptions: 'לא נמצאו תוצאות',
    },
    UserIconMenu: {
        settings: 'הגדרות',
    },
    deletedUserTable: {
        emailNotAssigned: 'לא הוכנס מייל',
        columns: {
            fullName: 'שם מלא',
            firstName: 'שם פרטי',
            lastName: 'שם משפחה',
            phoneNumber: 'פלאפון',
            email: 'מייל',
            firstLoginDate: 'תאריך הצטרפות',
            deletedDate: 'תאריך מחיקה',
            userDetails: 'פרטי המשתמש'
        },
    },
    deletedUsersPage: {
        buttons: {
            downloadCsv: 'הורדת דוחות',
            downloadCsvForOrganizations: 'ייצוא משתמשים מחוקים עבור היחידות הארגוניות הנבחרות',
            restoreUsers: 'שחזור משתמשים',
        }
    },
    restoreUsersModal: {
        title: 'שחזור משתמשים מחוקים',
        resultsTitle: 'תוצאות השחזור',
        confirmMessage: (key, {userCount}) => `את/ה עומד/ת לשחזר ${userCount} משתמש/ים. להמשיך?`,
        confirmHint: 'המשתמשים המשוחזרים ישויכו מחדש לארגונים הקודמים שלהם.',
        restoreUsers: 'שחזור משתמשים',
        restoring: 'משחזר...',
        restoreError: 'אירעה שגיאה במהלך שחזור המשתמשים. אנא נסה/י שוב.',
        successMessage: (key, {restored}) => `שוחזרו בהצלחה ${restored} משתמשים`,
        noRestoredMessage: 'לא שוחזרו משתמשים',
        restoredUsersTitle: 'משתמשים ששוחזרו',
        skippedUsersTitle: 'משתמשים שלא שוחזרו',
        skippedExplanationTitle: 'מדוע חלק מהמשתמשים לא שוחזרו?',
        skippedExplanation: 'חלק מהמשתמשים לא יכלו לעבור שחזור עקב שגיאות פנימיות. נסה/י שוב או צור/י קשר עם התמיכה אם הבעיה נמשכת.',
        firstName: 'שם פרטי',
        lastName: 'שם משפחה',
        email: 'אימייל',
        employeeID: 'מספר עובד',
        idNumber: 'תעודת זהות',
        organizations: 'יחידות ארגוניות',
        skipReason: 'סיבה',
        reasons: {
            restore_failed: 'אירעה שגיאה במהלך השחזור',
        },
    },
    deletedUserModal: {
        title: 'המסמכים והלומדות שהיו משוייכים ל',
        columns: {
            docName: 'שם המשימה',
            status: 'סטטוס',
            completedOnDate: 'תאריך סיום',
            expiryDate: 'תאריך תפוגה',
            type: 'סוג משימה',
            category: 'קטגוריה',
            score: 'ציון',
            actions: 'פעולות',
        },
        status: {
            finished: 'סיים/ה',
            inProgress: 'בתהליך',
            waitingForApproval: 'ממתין לאישור',
            notStarted: 'לא התחיל/ה',
            signed: 'חתם/ה'
        },
        signDocData: {
            unCompletedCourse: 'המשימה לא הושלמה',
            completedByAdmin: 'הושלם על ידי מנהל/ת חברה',
            doNotForceCompletion: 'העשרה',
        }
    },
    userDetailsModal: {
        learningPath: {
            expandTasks: 'הצגת משימות מסלול הלמידה',
            collapseTasks: 'הסתרת משימות מסלול הלמידה'
        },
        progressSummary: {
            title: 'סיכום התקדמות',
            completed: 'הושלמו',
            inProgress: 'בתהליך',
            notStarted: 'לא התחיל/ה',
            tasksCompleted: 'משימות הושלמו'
        },
        statusFilter: {
            archived: 'בארכיון'
        },
        archivedTag: 'ארכיון',
        actions: {
            updateExpiryDate: 'עדכון תאריך תפוגה',
            declineApproval: 'דחיית אישור',
            markAttended: 'סימון כנוכח',
            markNoShow: 'סימון כנעדר'
        }
    },
    FirstLoginModal: {
        title: 'איזה כיף שמתחילים ללמוד יחד!',
        content: 'עליך לבצע את המשימות הפתוחות במסך הבית עד לתאריך היעד.\nבהצלחה!',
        takeMeHome: 'מעולה, קחו אותי למסך הבית'
    },
    organizationalUnitTable: {
        columns: {
            organizationalUnitName: 'שם היחידה הארגונית',
            createAt: 'נוצר בתאריך',
            details: 'פרטים',
            delete: 'מחיקה',
            userCount: 'מספר משתמשים',
            updateOrgName: "עדכון שמות יחידות ארגוניות"
        },
        removeOrgCell: {
            columns: {
                firstName: 'שם פרטי',
                lastName: 'שם משפחה',
                organizationChange: 'שינוי יחידה ארגונית',
                deleteUSer: 'מחיקת משתמש'
            },
            modalNotAllowedDeleteTitle: 'בכדי למחוק יחידה ארגונית עלייך לשייך את כל המשתמשים\n ליחידה ארגונית אחרת אחת לפחות או למחוק אותם',
            modalAllowDeleteTitle: 'אין משתמשים בארגון אתה בטוח שאתה רוצה למחוק את הארגון?',
            button: 'למחיקת יחידה ארגונית',
            tooltipMessage: 'כדי למחוק ארגון אתה חייב למחוק או להוציא משיוך את כל המשתמשים בתוך הארגון',
            alertErrorDeleteOrgTitle: 'שגיאה במחיקת הארגון',
            failedDeleteOrgError: 'לא הצלחנו למחוק את הארגון מצטערים! אנא רענן את הדף ונסה שנית'
        },
        editOrgNameCell: {
            button: 'לעדכון שם יחידה ארגונית',
        }
    },
    questionnaire: {
        buttons: {
            continueToQuestionPool: ' שמור והמשך לעריכת השאלות'
        },
        modal: {
            title: 'יצירת שאלון חדש',
            passGrade: 'ציון עובר',
            timeToFinish: 'זמן המבחן',
            canUserReview: 'האם לאפשר לנבחן לעבור על התשובות',
            allowedTries: 'נסיונות אפשריים'
        }
    },
    questionnaireQuestions: {
        questionText: 'טקסט השאלה',
        questionType: 'סוג השאלה',
        options: 'אפשרויות',
        markAsCorrect: 'סמן כתשובה נכונה',
        addOption: 'הוסף אפשרות',
        headers: {
            'EXAM': 'מבחן',
            'SURVEY': 'סקר',
            poolQuestionSubTitle: 'מספר שאלות',
        },
        buttons: {
            saveQuestions: 'שמירת שאלות',
            saveQuestionsSubTitle: 'לחץ לשמירת השאלות',
            addOption: 'הוספת אפשרות',
            genAIQuestions: 'צור שאלות ב AI',
        },
        aiModal: {
            questionQuantityLabel: 'כמות שאלות ליצירה',
        },
        placeHolders: {
            questionText: 'הכנס את השאלה כאן...',
            question: 'הכנס את השאלה כאן...',
            option: 'אפשרות',
            aiDescription: 'הסבר קצר',
            aiSubject: 'נושא',
            aiQuestionCount: 'כמות שאלות',
            MULTIPLE_CHOICE: 'שאלת בחירה מרובה - הוסף אפשרויות תשובה',
            CHECKBOX: 'שאלת תיבות סימון - הוסף אפשרויות תשובה',
            FREE_TEXT: 'שאלת טקסט חופשי - המשתמש יכתוב תשובה חופשית',
            RATING_SCALE: 'שאלת דירוג - המשתמש יבחר דירוג מ-1 עד 10',
        },
        questionOptions: {
            MULTIPLE_CHOICE: 'פתרון יחיד',
            CHECKBOX: 'בחירה מרובה',
            FREE_TEXT: 'שאלה פתוחה',
            RATING_SCALE: 'סולם דירוג',
        },
        aiLoadingTexts: {
            loading: 'יוצר שאלות עבורך...',
            testWillBeReadySoon: 'המבחן יהיה מוכן בקרוב...',
            aBitMorePatience: 'עוד קצת סבלנות...',
            pleaseWait: 'אנא המתן...',
            itMightTakeABitLongerButItsWorthIt: 'זה עלול לקחת קצת יותר זמן אבל זה שווה את זה...',
        },
        validation: {
            modalTitle: 'נמצאו שגיאות בשאלות',
            questionIndexError: 'שאלה מספר',
            navigateToQuestion: 'עבור לשאלה',
            closeAndFix: 'סגור ותקן',
            emptyOptionValue: 'בשאלה קיימת אופציה ללא תוכן',
            duplicateOptions: 'בשאלה קיימות אופציות שהתוכן שלהן זהה',
            noCorrectAnswer: 'בשאלה לא נבחרה תשובה נכונה',
            minimumOptions: 'בשאלה יש צורך להגדיר לפחות 2 אפשרויות',
        },
        survey: {
            anonymousToggle: 'סקר אנונימי',
            anonymousDescription: 'כאשר מופעל, לא יישמרו פרטי המשתמשים שמילאו את הסקר',
            ratingScale: {
                title: 'הגדרות סולם דירוג',
                minValue: 'ערך מינימלי',
                maxValue: 'ערך מקסימלי',
                minLabel: 'תווית מינימום',
                maxLabel: 'תווית מקסימום',
                defaultMinLabel: 'לא מרוצה',
                defaultMaxLabel: 'מרוצה מאוד',
                previewTitle: 'תצוגה מקדימה',
            }
        },
        tooltips: {
            pleaseFillSubject: 'אנא הכנס נושא לשאלות',
        },
        addImage: 'הוסף תמונה לשאלה',
        hasImage: 'השאלה מכילה תמונה',
        dropImageOrClick: 'גרור תמונה לכאן או לחץ לבחירה',
        uploading: 'מעלה תמונה...',
        supportedFormats: 'פורמטים נתמכים',
        deleteImageTitle: 'מחיקת תמונה',
        confirmDeleteImage: 'האם אתה בטוח שברצונך למחוק את התמונה?',
        errors: {
            invalidImageType: 'סוג קובץ לא נתמך. אנא העלה תמונה בפורמט JPG, PNG, GIF או WEBP',
            imageTooLarge: 'גודל הקובץ חורג מ-10MB',
            uploadFailed: 'העלאת התמונה נכשלה',
            deleteFailed: 'מחיקת התמונה נכשלה',
        }
    },
    questionnaireSession: {
        imageLoadError: 'טעינת התמונה נכשלה',
        modal: {
            finishExam: 'האם את/ה בטוח/ה שאת/ה רוצה לסיים את המבחן?',
            finishExamTitle: 'סיום מבחן',
            finishExamWithUnansweredQuestions: 'האם את/ה בטוח/ה שברצונך לסיים? ישנן שאלות שלא נענו',
            closeAndReturnToTest: 'חזור למבחן'

        },
        finishModal: {
            congratsTitle: 'כל הכבוד!',
            congratsMessage: 'עברת את המבחן בהצלחה',
            oopsTitle: 'אופס...',
            oopsMessage: 'נראה שלא עברת את המבחן',
        },
        buttons: {
            previousQuestion: 'שאלה קודמת',
            nextQuestion: 'שאלה הבאה',
            finishExam: 'סיים את המבחן',
            congratsModal: 'מעולה, קחו אותי למסך הבית',
            oopsBackToHomePage: 'חזרה למסך הבית',
        },
        errors: {
            notAllQuestionsAnswered: 'לא כל השאלות נענו. האם את/ה בטוח/ה שברצונך לסיים?',
        },
    },
    surveySession: {
        finishModal: {
            congratsTitle: 'תודה רבה!',
            congratsMessage: 'תודה רבה על השתתפותכם בסקר! \n התרומה שלכם חשובה לנו מאוד.',
        },
        defaultTitle: "סקר",
        buttons: {
            previousQuestion: "שאלה קודמת",
            nextQuestion: "שאלה הבאה",
            finishSurvey: "סיום סקר",
            congratsModal: 'מעולה, קחו אותי למסך הבית',
        },
        placeHolders: {
            FREE_TEXT: 'התשובה שלך',
        },
        modal: {
            finishSurveyTitle: "סיום סקר",
            finishSurvey: "האם אתם בטוחים שאתם רוצים לסיים את הסקר? ניתן לחזור ולשנות תשובות לפני הסיום.",
            closeAndReturnToSurvey: "חזור לסקר"
        },
        success: {
            title: "תודה רבה!",
            anonymousMessage: "התשובות שלכם נשמרו באופן אנונימי",
            identifiedMessage: "התשובות שלכם נשמרו בהצלחה במערכת",
            thankYou: "תודה לכם על השתתפותכם בסקר! התרומה שלכם חשובה לנו מאוד.",
            anonymousConfirmation: "המידע שלכם נשמר באופן אנונימי ולא ניתן לזהות אתכם",
            goHome: "חזרה לעמוד הבית"
        }
    },
    surveyInstruction: {
        title: 'לפני שנתחיל, כמה דגשים...',
        info1:(key, {numberOfQuestions}) =>  `הסקר מורכב מ - ${numberOfQuestions} שאלות`,
        info2: 'נשמח לשמוע את דעתכם',
        info3: 'ההשתתפות בסקר היא וולונטרית',
        info4: 'תוכלו לדלג על שאלות שאינכם רוצים לענות עליהן',
        anonymous: "הסקר הוא אנונימי לחלוטין",
        anonymousNotice: "התשובות שלכם יישמרו באופן אנונימי ולא ניתן יהיה לדעת איזה תשובות עניתם בשום צורה",
        thankYou: 'תודה רבה על השתתפותכם!',
        startButton: 'התחל סקר'
    },
    questionnaireInstruction: {
        title: 'לפני שנתחיל, כמה דגשים...',
        info1:(key, {numberOfQuestions}) =>  `המבחן מורכב מ - ${numberOfQuestions} שאלות`,
        info2:(key, {passGrade}) =>  `ציון עובר למבחן - ${passGrade}`,
        info3: 'יש למלא את כל השאלות בטרם ההגשה',
        successInfo: 'עברת? ',
        failInfo: 'לא עברת? ',
        info4: 'איזה כיף, סיימת/ת את המשימה. ',
        info5: 'יש לבצע מבחן חוזר',
        goodLuck: 'בהצלחה!',
        startButton: 'התחלה'
    },
    weezbeeCourse: {
        addContent: 'הוסף תוכן',
        contentType: 'סוג תוכן',
        contentTypes: {
            text: 'טקסט',
            video: 'וידאו',
            image: 'תמונה',
            quiz: 'חידון',
            pdf: 'PDF'
        },
        orientationOverlay: {
            title: 'אנא סובב את המכשיר שלך',
            message: 'לחוויה טובה יותר, אנא סובב את המכשיר שלך למצב אופקי.'
        },
        fullscreenPrompt: {
            title: 'הצג קורס במסך מלא',
            buttonText: 'כניסה למסך מלא',
            errors: {
                permissionDenied: 'ההרשאה נדחתה. אנא נסה שוב על ידי לחיצה על כפתור מסך מלא.',
                generic: 'שגיאת מסך מלא: {message}'
            }
        },
        chapterPanel: {
            title: 'פרקים לביצוע',
            generating: 'מייצר...',
            aiCreating: 'בינה מלאכותית יוצרת את הפרק הזה...',
            deleteChapter: 'מחק פרק',
            duplicateChapter: 'שכפל פרק',
            copySuffix: '(עותק)',
        },
        question: {
            defaultText: 'הכנס את שאלתך כאן',
            tryAgain: 'אופס, תשובה שגויה. נסה שוב!',
            submitAnswer: 'שלח תשובה',
            correct: 'נכון!',
            incorrect: 'לא נכון',
        },
        navigation: {
            back: 'הקודם',
            next: 'הבא'
        },
        aiGeneration: {
            generateCourse: 'צור קורס עם AI',
            courseLengthMinutes: 'אורך הקורס (דקות)',
            courseLengthMinutesHelp: 'הזן ערך בין 5-30 דקות',
            descriptionPlaceholder: 'תיאור קצר של הקורס...',
            tooltip: {
                pleaseEnterDescription: 'אנא הזן תיאור של הקורס (5-150 תווים)',
                pleaseEnterValidCourseLength: 'אנא הזן אורך קורס תקין (5-30 דקות)'
            },
            loadingTexts: {
                loading: 'יוצרים קורס עבורך...',
                pleaseWait: 'אנא המתן...',
                courseWillBeReadySoon: 'הקורס שלך יהיה מוכן בקרוב...',
                aBitMorePatience: 'עוד קצת סבלנות...',
                itMightTakeABitLongerButItsWorthIt: 'זה עלול לקחת עוד כמה שניות אבל זה יהיה שווה את זה...',
            },
        },
        aiWizard: {
            openWizardButton: 'צור קורס עם AI',
            wizardTitle: 'אשף יצירת קורס עם בינה מלאכותית',
            step1Label: 'פרטי הקורס',
            step2Label: 'בחירת תבנית',
            subjectLabel: 'נושא הקורס',
            subjectPlaceholder: 'הזן את הנושא המרכזי של הקורס...',
            promptLabel: 'הנחיות נוספות לבינה המלאכותית (אופציונלי)',
            promptPlaceholder: 'ספק הנחיות ספציפיות לבינה המלאכותית...',
            uploadFileButton: 'העלה קובץ עזר (PDF/TXT)',
            fileUploaded: 'קובץ הועלה: {fileName}',
            removeFile: 'הסר קובץ',
            characterLimitExceeded: 'חריגה ממגבלת התווים. אנא צמצם את התוכן.',
            subjectRequired: 'נושא הקורס הוא שדה חובה',
            validationError: 'אנא תקן את השגיאות לפני המשך',
            fileTooLarge: 'הקובץ גדול מדי. גודל מקסימלי: {maxSize}MB',
            unsupportedFileType: 'סוג קובץ לא נתמך. אנא העלה קובץ PDF או TXT',
            fileReadError: 'שגיאה בקריאת הקובץ. אנא נסה שוב',
            extractingFile: 'מחלץ טקסט מהקובץ...',
            extractError: 'שגיאה בחילוץ טקסט מהקובץ',
            generateButton: 'צור קורס',
            generatingButton: 'יוצר...',
        },
        aiContextGenerator: {
            title: 'הקשר לבינה מלאכותית',
        },
        content: {
            title: 'כותרת',
            description: 'תיאור',
            text: 'תוכן טקסטואלי',
            videoUrl: 'קישור לוידאו',
            addQuestion: 'הוסף שאלה',
            question: 'שאלה',
            option: 'אפשרות {number}',
            correctAnswer: 'תשובה נכונה'
        },
        editor: {
            pagination: {
                pageInfo: (key, {current, total}) => `עמוד ${current} מתוך ${total}`
            },
            backgroundSelector: {
                image: 'תמונה',
                video: 'וידאו'
            },
            editorTitle: 'עורך הקורס',
            chapterNumber: (key, {number}) => `פרק ${number}`,
            addSection: 'הוסף פרק',
            editSection: 'עריכת פרק',
            preview: 'תצוגה מקדימה',
            switchToViewMode: 'עבור למצב תצוגה',
            switchToEditMode: 'עבור למצב עריכה',
            enterFullscreen: 'מסך מלא',
            exitFullscreen: 'יציאה ממסך מלא',
            saveCourse: 'שמירת קורס',
            saveCourseSubTitle: 'לחץ לשמירת הקורס',
            previewMode: 'מצב תצוגה',
            editMode: 'מצב עריכה',
            templateMode: 'מצב תבנית',
            courseMode: 'מצב קורס',
            switchToTemplateMode: 'עבור למצב תבנית',
            switchToCourseMode: 'עבור למצב קורס',
            templateDetails: 'הגדרות תבנית קורס',
            templateName: 'שם התבנית',
            templateSubject: 'קטגוריה / תחום נושא',
            templateDescription: 'תיאור התבנית',
            templateTags: 'תגיות (מופרדות בפסיקים)',
            templatePublic: 'נגיש לציבור',
            templateReady: 'מוכן לשימוש',
            saveTemplate: 'שמור תבנית',
            templateValidationError: 'שם תבנית ונושא הם שדות חובה',
            templateSaved: 'התבנית נשמרה בהצלחה!',
            templateUpdated: 'התבנית עודכנה בהצלחה!',
            templateSaveError: 'שגיאה בשמירת התבנית. אנא נסה שוב.',
            templateCreateError: 'שגיאה ביצירת תבנית חדשה. אנא נסה שוב.',
            fetchError: 'שגיאה בטעינת קורס או תבנית. אנא נסה שוב.',
            defaultCourseTitle: 'קורס',
            defaultCourseDescription: '',
            templateNamePlaceholder: 'הזן כותרת תיאורית לתבנית זו',
            templateSubjectPlaceholder: 'לדוגמה: הדרכת בטיחות, קליטת עובדים, מנהיגות',
            templateDescriptionPlaceholder: 'ספק תיאור מפורט של מה שהתבנית מכסה ולמי היא מיועדת',
            templateTagsPlaceholder: 'הוסף מילות מפתח שיעזרו למשתמשים למצוא את התבנית הזו (מופרדות בפסיקים)',
            templateSelectorTitle: 'צור או בחר תבנית',
            createNewTemplate: 'צור תבנית חדשה',
            createNewTemplateDesc: 'התחל עם תבנית ריקה ובנה אותה מאפס.',
            createTemplate: 'צור תבנית',
            selectExistingTemplate: 'בחר תבנית קיימת',
            selectExistingTemplateDesc: 'בחר מהתבניות הקיימות שלך לעריכה.',
            browseTemplates: 'עיין בתבניות',
            publicAssetBank: 'בנק נכסים ציבורי',
            publicAssetBankDescription: 'נכסים שנוספו כאן יהיו זמינים לכל התבניות',
            uploadPublicAsset: 'העלאת נכס ציבורי',
            publicAssetUploaded: 'הנכס הציבורי הועלה בהצלחה!',
            publicAssetUploadError: 'שגיאה בהעלאת נכס ציבורי. אנא נסה שוב.',
            templateAssetName: 'נכס תבנית',
            templateAssetDescription: 'הועלה מעורך התבנית',
            componentBank: {
                title: 'בנק רכיבים',
                description: 'גרור או לחץ להוספת רכיבים',
                text: {
                    name: 'טקסט',
                    description: 'רכיב טקסט פשוט'
                },
                bullets: {
                    name: 'נקודות',
                    description: 'רכיב רשימת נקודות'
                },
                logo: {
                    name: 'לוגו',
                    description: 'רכיב לוגו חברה',
                    missingLogo: 'לוגו החברה חסר'
                },
                image: {
                    name: 'תמונה',
                    description: 'רכיב תמונה'
                },
                video: {
                    name: 'וידאו',
                    description: 'רכיב וידאו'
                },
                shape: {
                    name: 'צורה',
                    description: 'רכיב צורות בסיסיות'
                },
                question: {
                    name: 'שאלה',
                    description: 'רכיב שאלה אינטראקטיבית'
                }
            },
            chapterEditor: {
                title: 'עורך פרקים',
                description: 'ערוך את תוכן הפרק שלך',
                contentTitle: 'קנבס',
                canvasDescription: 'גרור רכיבים אל הקנבס ומקם אותם בחופשיות',
                emptyState: 'אין רכיבים שנוספו עדיין. גרור רכיבים מהבנק או לחץ להוספה.',
                removeComponent: 'הסר רכיב'
            },
            textComponent: {
                placeholder: 'הזן את הטקסט שלך כאן...',
                emptyState: 'לחץ להוספת טקסט'
            },
            bulletsComponent: {
                placeholder: 'הזן טקסט נקודה...',
                emptyState: 'נקודה ריקה',
                removeBullet: 'הסר נקודה',
                addBullet: 'הוסף נקודה'
            },
            logoComponent: {
                altText: 'לוגו החברה',
                missingLogo: 'לוגו החברה חסר',
                borderRadius: 'רדיוס גבול',
                backgroundColor: 'צבע רקע',
                opacity: 'שקיפות'
            },
            imageComponent: {
                altText: 'תמונה',
                placeholder: 'לחץ להוספת תמונה',
                selectorTitle: 'בחר תמונה',
                uploadNew: 'העלה חדש',
                imageBank: 'בנק תמונות',
                loading: 'טוען...',
                emptyBank: 'אין תמונות בבנק',
                cancel: 'ביטול',
                enterUrl: 'הזן כתובת URL',
                urlPlaceholder: 'https://example.com/image.jpg',
                submit: 'שלח',
                changeSource: 'שנה תמונה'
            },
            backgroundImageComponent: {
                altText: 'תמונת רקע',
                placeholder: 'לחץ להוספת תמונת רקע',
                selectorTitle: 'בחר תמונת רקע',
                uploadNew: 'העלה חדש',
                imageBank: 'בנק תמונות',
                loading: 'טוען...',
                emptyBank: 'אין תמונות בבנק',
                cancel: 'ביטול',
                enterUrl: 'הזן כתובת URL',
                urlPlaceholder: 'https://example.com/image.jpg',
                submit: 'שלח',
                changeSource: 'שנה תמונת רקע'
            },
            videoComponent: {
                altText: 'וידאו',
                placeholder: 'לחץ להוספת וידאו',
                selectorTitle: 'בחר וידאו',
                uploadNew: 'העלה חדש',
                videoBank: 'בנק וידאו',
                loading: 'טוען...',
                emptyBank: 'אין וידאו בבנק',
                cancel: 'ביטול',
                enterUrl: 'הזן כתובת URL',
                urlPlaceholder: 'https://example.com/video.mp4',
                submit: 'שלח',
                changeSource: 'שנה וידאו',
                errorTitle: 'הוידאו לא נטען',
                errorMessage: 'לא ניתן לטעון את הוידאו. אנא העלה וידאו חדש או בחר אחר מבנק הוידאו.',
                retry: 'נסה שוב',
                selectAnother: 'בחר וידאו אחר',
                edit: 'ערוך'
            },
            shapeComponent: {
                emptyState: 'לחץ לבחירת צורה',
                rectangle: 'מלבן',
                circle: 'עיגול',
                triangle: 'משולש',
                star: 'כוכב'
            },
            fields: {
                title: 'כותרת',
                description: 'תיאור',
                content: 'תוכן',
                videoUrl: 'קישור לוידאו',
            },
            title: {
                label: 'כותרת',
                defaultValue: 'פרק חדש'
            },
            description: {
                label: 'תיאור',
                defaultValue: 'תיאור הפרק'
            },
            headTitle: {
                label: 'כותרת ראשית',
                defaultValue: 'פרק חדש'
            },

            color: {
                placeholder: '#000000'
            },
            component: {
                borderRadius: 'רדיוס גבול',
                backgroundColor: 'צבע רקע',
                opacity: 'שקיפות',
                textDirection: 'כיוון טקסט',
                leftToRight: 'משמאל לימין',
                rightToLeft: 'מימין לשמאל',
                pixelUnit: 'פיקסל',
                percentUnit: '%',
                colorValue: (key, { color }) => color,
                backgroundColorValue: (key, { color }) => color,
                borderRadiusAll: 'הכל'
            },
            backgroundImage: {
                label: 'תמונת רקע',
                placeholder: 'הזן כתובת URL של תמונה',
                uploadButton: 'העלה תמונה',
                previewAlt: 'תצוגה מקדימה של הרקע',
                invalidImageUrl: 'https://via.placeholder.com/400x200?text=כתובת+תמונה+לא+תקינה'
            },
            logoImage: {
                label: 'לוגו',
                placeholder: 'הזן כתובת URL של לוגו',
                uploadButton: 'העלה לוגו',
                previewAlt: 'תצוגה מקדימה של הלוגו',
                invalidImageUrl: 'https://via.placeholder.com/400x200?text=כתובת+לוגו+לא+תקינה'
            },
            backgroundImageEditor: {
                title: 'עריכת תמונת רקע',
                opacity: 'שקיפות',
                backgroundColor: 'צבע רקע',
                transparent: 'שקוף',
                save: 'שמור שינויים',
                remove: 'הסר תמונת רקע',
                cancel: 'ביטול'
            },
            backgroundVideoEditor: {
                title: 'עריכת וידאו רקע',
                opacity: 'שקיפות',
                backgroundColor: 'צבע רקע',
                transparent: 'שקוף',
                save: 'שמור שינויים',
                remove: 'הסר וידאו רקע',
                cancel: 'ביטול'
            },
            backgroundVideoComponent: {
                changeSource: 'שנה מקור וידאו',
                enterUrl: 'הזן כתובת URL של וידאו',
                urlPlaceholder: 'https://example.com/video.mp4',
                submit: 'החל',
                cancel: 'ביטול',
                uploadNew: 'העלה וידאו חדש',
                loading: 'טוען...',
                videoBank: 'מאגר וידאו',
                backgroundVideoBank: 'מאגר וידאו רקע',
                emptyBank: 'לא נמצאו וידאו במאגר הוידאו.'
            },
            editorDrawer: {
                title: 'עריכת רכיב',
                closeButton: 'סגור',
                description: 'התאם אישית את הרכיב הנבחר',
                typography: 'טיפוגרפיה',
                textFormatting: 'עיצוב טקסט',
                fontSize: 'גודל גופן',
                textColor: 'צבע טקסט',
                shapeType: 'סוג צורה',
                shapeColor: 'צבע צורה',
                shapeBackground: 'רקע צורה',
                colorMode: 'צבע',
                gradientMode: 'גרדיאנט',
                gradientColor1: 'צבע ראשון',
                gradientColor2: 'צבע שני',
                gradientAngle: 'זווית גרדיאנט',
                borderGradientColor1: 'צבע ראשון',
                borderGradientColor2: 'צבע שני',
                borderGradientAngle: 'זווית גרדיאנט',
                shapeOpacity: 'שקיפות צורה',
                borderWidth: 'עובי גבול',
                borderColor: 'צבע גבול',
                border: 'גבול',
                style: 'עיצוב',
                background: 'רקע'
            },
            videoUrl: {
                label: 'כתובת URL של וידאו',
                placeholder: 'הזן כתובת URL של YouTube או וידאו'
            },
            // Default values for new chapters
            textContent: {
                label: 'תוכן טקסט',
                defaultValue: 'הזן את התוכן שלך כאן',
                placeholder: 'הזן את התוכן שלך כאן'
            },
            bullets: {
                defaultValue1: 'נקודה 1',
                defaultValue2: 'נקודה 2',
                defaultValue3: 'נקודה 3',
                label: 'נקודות',
                remove: 'הסר',
                add: 'הוסף נקודה',
                addPlaceholder: 'הוסף נקודה חדשה...'
            },
            // Template selection
            templateSelectionInstruction: 'בחר תבנית לפרק החדש שלך:',
            featureBadges: {
                video: 'וידאו',
                bullets: 'נקודות',
                textContent: 'תוכן טקסט',
                'text-content': 'תוכן טקסט',
                heading: 'כותרת'
            }
        },
        templateBank: {
            title: 'בחר תבנית',
            description: 'בחר תבנית לפרק החדש שלך',
            closeButton: 'סגור בנק תבניות',
            selectTemplate: (key, { templateName }) => `בחר תבנית ${templateName}`,
            directionSelection: 'בחר כיוון תבנית:',
            ltrDirection: 'כיוון משמאל לימין',
            rtlDirection: 'כיוון מימין לשמאל',
            ltrLabel: 'LTR',
            rtlLabel: 'RTL',
            templates: {
                standardSlide: {
                    name: 'שקופית סטנדרטית',
                    description: 'שקופית סטנדרטית עם לוגו, כותרת, טקסט בצד ימין ותמונה בצד שמאל'
                },
                videoFocused: {
                    name: 'מיקוד בוידאו',
                    description: 'שקופית עם וידאו גדול במרכז וטקסט תומך מתחת'
                },
                bulletPoints: {
                    name: 'נקודות מפתח',
                    description: 'שקופית המתמקדת בנקודות מפתח למידע חשוב'
                },
                centeredImage: {
                    name: 'תמונה במרכז',
                    description: 'שקופית עם תמונה גדולה במרכז וטקסט כיתוב מתחת'
                },
                textAndBullets: {
                    name: 'טקסט ונקודות',
                    description: 'שקופית עם טקסט בצד שמאל ונקודות מפתח בצד ימין'
                },
                videoAndBullets: {
                    name: 'וידאו ונקודות',
                    description: 'שקופית עם וידאו בצד שמאל ונקודות מפתח בצד ימין'
                },
                twoColumnImage: {
                    name: 'שתי תמונות זו לצד זו',
                    description: 'שקופית עם שתי תמונות זו לצד זו וכיתוב מתחת'
                },
                threeColumnText: {
                    name: 'שלוש עמודות טקסט',
                    description: 'שקופית עם שלוש עמודות טקסט להשוואה או רשימת מידע קשור'
                },
                imageGallery: {
                    name: 'גלריית תמונות',
                    description: 'שקופית עם ארבע תמונות מסודרות ברשת עם כיתוב מתחת'
                },
                videoWithOverlay: {
                    name: 'וידאו עם טקסט מודגש',
                    description: 'שקופית עם וידאו וטקסט מודגש להדגשת נקודות מפתח'
                },
                titleWithBackground: {
                    name: 'כותרת על רקע תמונה',
                    description: 'שקופית עם כותרת וטקסט על רקע תמונה ליצירת אפקט דרמטי'
                }
            },
            content: {
                slideTitle: 'כותרת השקופית',
                loremIpsum: 'לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית. נולום ארווס סאפיאן, פוסיליס קוויס, אקווזמן קוואזי במר מודוף.',
                videoTitle: 'מצגת וידאו',
                videoDescription: 'וידאו זה מסביר את המושגים המרכזיים של הנושא. צפה בו בתשומת לב כדי להבין את הרעיונות העיקריים.',
                bulletTitle: 'נקודות מפתח',
                bullet1: 'נקודה ראשונה חשובה לזכור בנושא זה',
                bullet2: 'מושג מפתח שני שמתבסס על הנקודה הראשונה',
                bullet3: 'אלמנט חיוני שלישי שמשלים את ההבנה',
                imageTitle: 'ייצוג חזותי',
                imageCaption: 'תמונה זו ממחישה את המושג המתואר בפרק זה. למד אותה בקפידה כדי להבין את האלמנטים החזותיים.',
                textBulletTitle: 'סקירת מושג',
                textContent: 'חלק זה מספק הסבר מפורט של המושג. הטקסט מציג את הרעיונות העיקריים ומספק הקשר להבנת הנקודות המרכזיות המפורטות בצד ימין.',
                textBullet1: 'נקודת מפתח הקשורה למושג המוסבר בטקסט',
                textBullet2: 'מידע נוסף התומך במושג העיקרי',
                textBullet3: 'נקודה אחרונה המשלימה את הבנת הנושא',
                videoBulletTitle: 'הדרכת וידאו עם נקודות מפתח',
                videoBullet1: 'צפה בוידאו כדי להבין את ההדגמה',
                videoBullet2: 'עקוב אחר השלבים המוצגים בוידאו',
                videoBullet3: 'התייחס לנקודות אלה בזמן הצפייה בוידאו',

                // Two-column image template content
                twoColumnImageTitle: 'השוואת תמונות',
                twoColumnImageCaption: 'תמונות אלה ממחישות היבטים שונים של המושג. השווה ביניהן כדי להבין את ההבדלים והדמיון העיקריים.',

                // Three-column text template content
                threeColumnTitle: 'תהליך בשלושה שלבים',
                column1Text: 'שלב 1: התחל בהבנת העקרונות הבסיסיים והיסודות של המושג. שלב ראשוני זה הוא קריטי לבניית הבנה מוצקה.',
                column2Text: 'שלב 2: יישם את העקרונות בתרחישים מעשיים וחקור כיצד הם מתקשרים למצבים בעולם האמיתי. תרגול הוא חיוני להשגת מומחיות.',
                column3Text: 'שלב 3: הערך את ההבנה שלך ושפר את הגישה שלך בהתבסס על משוב ותוצאות. שיפור מתמיד מוביל למומחיות.',

                // Image gallery template content
                imageGalleryTitle: 'גלריית דוגמאות חזותיות',
                imageGalleryCaption: 'אוסף תמונות זה מדגים היבטים שונים של הנושא. כל תמונה מייצגת דוגמה או יישום שונה.',

                // Video with overlay template content
                videoOverlayTitle: 'וידאו עם הדגשים מרכזיים',
                videoOverlayText: 'חשוב: שים לב מיוחדת להדגמה זו המציגה טכניקות קריטיות.',

                // Title with background template content
                backgroundTitle: 'סקירת הפרק',
                backgroundSubtitle: 'מושגים ועקרונות חיוניים',
                backgroundText: 'פרק זה מציג מושגים יסודיים המהווים את הבסיס לנושא. הבנת עקרונות אלה היא קריטית לשליטה בנושאים המתקדמים יותר שיבואו בהמשך.'
            }
        },
        courseTemplateBank: {
            title: 'יצירת קורס עם בינה מלאכותית',
            description: 'בחר תבנית קורס ליצירת קורס חדש עם תוכן שנוצר על ידי בינה מלאכותית',
            courseTemplatesTitle: 'תבניות קורס',
            chapterTemplatesTitle: (key, { count }) => `שקופיות כלולות (${count})`,
            slideCount: (key, { count }) => `${count} שקופיות`,
            defaultCourseTitle: 'קורס חדש',
            defaultCourseDescription: 'קורס שנוצר עם בינה מלאכותית',
            defaultSectionTitle: 'חלק 1',
            cancelButton: 'ביטול',
            createButton: 'יצירת קורס',
            yourDescription: 'תיאור הקורס שלך:',
            defaultTemplatesTab: 'תבניות ברירת מחדל',
            designedTemplatesTab: 'תבניות מעוצבות',
            loadingTemplates: 'טוען תבניות...',
            noDesignedTemplates: 'אין תבניות מעוצבות זמינות כרגע.',
            estimatedDuration: (key, { duration }) => `${duration} דק'`,
            noDescription: 'אין תיאור זמין',
            noPreviewAvailable: 'אין תצוגה מקדימה זמינה',
            generationStartError: 'אירעה שגיאה בהתחלת יצירת הקורס. אנא נסה שוב.',
            courseTypes: {
                business: 'עסקים',
                technical: 'טכני',
                educational: 'חינוכי',
                onboarding: 'קליטת עובדים',
                compliance: 'ציות ורגולציה',
                product: 'מוצר'
            },
            templates: {
                businessCourse: {
                    name: 'קורס עסקי',
                    description: 'תבנית קורס עסקי מקיפה עם שקופיות המכסות מושגי עסקים מרכזיים, אסטרטגיות וניתוחי מקרה'
                },
                technicalCourse: {
                    name: 'קורס טכני',
                    description: 'תבנית קורס טכני מפורטת עם שקופיות המכסות מושגים טכניים, הדגמות ודוגמאות מעשיות'
                },
                educationalCourse: {
                    name: 'קורס חינוכי',
                    description: 'תבנית קורס חינוכי מובנית עם שקופיות המיועדות ללמידה יעילה ושימור ידע'
                },
                onboardingCourse: {
                    name: 'קורס קליטת עובדים',
                    description: 'תבנית קורס לקליטת עובדים עם שקופיות להצגת עובדים חדשים למדיניות החברה, נהלים ותרבות'
                },
                complianceCourse: {
                    name: 'קורס ציות ורגולציה',
                    description: 'תבנית קורס ציות עם שקופיות המכסות דרישות רגולטוריות, שיטות עבודה מומלצות ונהלי ציות'
                },
                productCourse: {
                    name: 'קורס מוצר',
                    description: 'תבנית קורס הדרכת מוצר עם שקופיות המציגות תכונות מוצר, יתרונות ודוגמאות שימוש'
                }
            }
        }
    },
    AIGeneration: {
        titles: {
            WEEZBEE_COURSE: 'צור קורס עם בינה מלאכותית',
            EXAM: 'צור מבחן עם בינה מלאכותית',
            SURVEY: 'צור סקר עם בינה מלאכותית',
            default: 'צור תוכן עם בינה מלאכותית',
        },
        buttonText: {
            WEEZBEE_COURSE: 'צור קורס עם AI',
            EXAM: 'צור שאלות עם AI',
            SURVEY: 'צור שאלות עם AI',
            default: 'צור תוכן עם AI',
        }
    },
    learningPath: {
        sequence: 'מסלול ההכשרה',
        noDocumentsSelected: 'לא נבחרו פרטי הדרכה',
        dropHere: 'גרור קובץ לכאן',
        editTitle: 'עריכת מסלול הכשרה',
        removeFromPath: 'להסיר מהמסלול',
        passingGradeRequired: 'ציון עובר נדרש: ',
        progressPercent: 'אחוז התקדמות:',
        buttons: {
            saveLearningPath: 'שמור מסלול',
            saveLearningPathSubTitle: 'שמור את הפריטים במסלול',
        },
        errors: {
            title: 'שגיאה',
            noDocuments: 'לא ניתן לשמור מסלול הכשרה עם פחות מ2 מסמכים',
            okText: 'אישור',
        },
        sequentialOnlyDisclaimer: 'מסלול למידה זה מוגדר כ"מחזורי" - ניתן להוסיף אליו רק משימות מחזוריות',
        freePath: {
            checkboxLabel: 'מסלול חופשי לבחירת משימות לביצוע',
            checkboxHelper: 'כאשר מופעל, משתמשים שמוקצים יכולים להתחיל כל משימה מיד ולהשלים אותן בכל סדר שיבחרו. כאשר מושבת, יש להשלים את המשימות לפי הסדר.',
            adminBanner: 'מצב מסלול חופשי מופעל. משתמשים שמוקצים יכולים להשלים משימות בכל סדר שיבחרו.',
            confirmSwitchToOrderedTitle: 'לעבור לסדר משימות רציף?',
            confirmSwitchToOrderedBody: 'מסלול למידה זה מוגדר כרגע כחופשי וכבר שויך למשתמשים. מעבר לסדר רציף יחייב את המשתמשים שמוקצים להשלים את המשימות לפי הסדר המוגדר. משתמשים שכבר השלימו משימות שלא לפי הסדר ישמרו את ההתקדמות שלהם, אך המשימה הבאה הזמינה תהיה הראשונה שלא הושלמה ברצף, מה שעלול להפתיע אותם. האם להמשיך?',
            confirmSwitchToOrderedConfirm: 'החלף למסלול מסודר',
            badge: 'מסלול חופשי',
        },
    },
    HoneycombTasks: {
        servicesText: {
            READ_AND_SIGN_DOC_PDF: 'קרא וחתום',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Youtube',
            WATCH_AND_SIGN_VIMEO_LINK: 'Viemo',
            WATCH_AND_SIGN_VIDEO_FILE: 'קובץ וידאו',
            CANVA_PRESENTATION: 'מצגת קנבה',
            EXAM: 'מבחן',
            LEARNING_PATH: 'מסלול הכשרה',
            REGULAR_COURSE: 'לומדה',
            FRONTAL_COURSE: 'הרצאה\n פרונטלית',
            AUDIO_FILE: 'קובץ שמע',
            PRESENTATION: 'מצגת',
            WEEZBEE_COURSE: 'לומדה',
            PODCAST: 'פודקאסט',
            ONLINE_COURSE: 'קורס מקוון',
            ARTICLE: 'מאמר',
            SURVEY: 'סקר',
            LINK: 'קישור',
            UPLOAD_DOCUMENT: 'העלאת מסמך',
        }
    },
    videoPlayer: {
        pleaseEnterVideoUrl: 'אנא הזן כתובת URL של וידאו',
    },
    imageBank: {
        title: 'מאגר תמונות החברה',
        noImages: 'לא נמצאו תמונות במאגר התמונות של החברה.',
        clickToCopy: 'לחץ להעתקת כתובת URL',
        urlCopied: 'כתובת URL של התמונה הועתקה ללוח!',
        copyFailed: 'העתקת כתובת URL נכשלה. אנא נסה להעתיק ידנית.',
        fetchError: 'טעינת התמונות נכשלה. אנא נסה שוב מאוחר יותר.',
        featureFlagDisabled: 'תכונת מאגר התמונות אינה מופעלת עבור החברה שלך.'
    },
    course: {
        untitled: 'קורס ללא כותרת',
        notFound: 'הקורס לא נמצא. אנא בדוק את הכתובת או צור קשר עם התמיכה.',
        fetchError: 'טעינת הקורס נכשלה. אנא נסה שוב מאוחר יותר.',
        loading: 'טוען קורס...',
        error: 'שגיאה בטעינת הקורס',
        error: {
            sessionDateRequired: 'יש להזין תאריך ושעת הקורס לפני הקצאה לארגונים'
        }
    },
    assetBank: {
        title: 'מאגר נכסים של החברה',
        publicTitle: 'מאגר נכסים ציבורי',
        noImages: 'לא נמצאו תמונות במאגר הנכסים של החברה.',
        noVideos: 'לא נמצאו סרטונים במאגר הנכסים של החברה.',
        clickToCopy: 'לחץ להעתקת כתובת URL',
        urlCopied: 'כתובת URL הועתקה ללוח!',
        copyFailed: 'העתקת כתובת URL נכשלה. אנא נסה להעתיק ידנית.',
        fetchImageError: 'טעינת התמונות נכשלה. אנא נסה שוב מאוחר יותר.',
        fetchVideoError: 'טעינת הסרטונים נכשלה. אנא נסה שוב מאוחר יותר.',
        imagesTab: 'תמונות',
        videosTab: 'סרטונים',
        featureFlagDisabled: 'תכונת מאגר הנכסים אינה מופעלת עבור החברה שלך.',
        addToChapterTooltip: 'הוסף לפרק',
        addToChapter: 'הוסף לפרק',
        addAsBackgroundTooltip: 'הוסף כרקע לפרק',
        addAsBackground: 'הוסף כרקע',
        addedToChapter: (key, { type }) => `${type === 'image' ? 'תמונה' : 'וידאו'} נוספה לפרק!`,
        addedAsBackground: 'התמונה נוספה כרקע לפרק!',
        addedAsBackgroundVideo: 'הוידאו נוסף כרקע לפרק!',
        uploadImage: 'העלה תמונה',
        uploadVideo: 'העלה סרטון',
        uploadSuccess: 'הקובץ הועלה בהצלחה',
        uploadError: 'שגיאה בהעלאת הקובץ',
        invalidFileType: 'סוג קובץ לא תקין',
        fileTooLarge: (key, { maxSize }) => `הקובץ גדול מדי. הגודל המקסימלי הוא ${maxSize}`
    },
    signDoc: {
        finishByDuration: {
            toggleLabel: 'הגדר זמן לביצוע המשימה',
            title: 'זמן להשלמה',
            note: 'מספר הימים שיש למשתמש להשלים את המשימה מרגע השיוך'
        },
        assignmentWarning: {
            title: 'אזהרת שיוך',
            editingWillBeLocked: 'אזהרה: לאחר שיוך המסמך ליחידות ארגוניות, לא יהיה ניתן לערוך את המסמך.',
            editingLocked: 'שים לב: עריכת המסמך אינה אפשרית בשל הקצאות קודמות ליחידות ארגוניות.',
            continueAssignment: 'שיוך מסמך',
            cancel: 'ביטול'
        },
        organizationAssignmentWarning: {
            title: 'לא נבחרו יחידות ארגוניות',
            message: 'לא שייכת את המשימה לאף יחידה ארגונית. זה אומר שהמשתמשים לא יוכלו לראות את המשימה.',
            subMessage: 'כדי שהמשתמשים יוכלו לגשת למשימה, עליך לשייך אותה לפחות ליחידה ארגונית אחת.',
            goBack: 'חזור לעריכה',
            continueWithoutAssignment: 'המשך בלי שיוך'
        },
        editDisabled: {
            assignedToOrganizations: 'עריכה מושבתת מכיוון שהמסמך שויך ליחידות ארגוניות. זה שומר על שלמות ההדרכה ומבטיח הערכה עקבית.',
            editQuestionsDisabled: 'עריכת שאלות מושבתת עבור מסמכים שהוקצו ליחידות ארגוניות'
        },
        duplicate: {
            button: 'שכפל כעותק לעריכה',
            modal: {
                title: 'שכפול מסמך',
                description: 'צור עותק חדש וניתן לעריכה של המסמך הזה עם כל השאלות שלו.',
                newNameLabel: 'שם המסמך החדש',
                newNamePlaceholder: 'עותק של {originalName}',
                newDescriptionLabel: 'תיאור המסמך החדש (אופציונלי)',
                newDescriptionPlaceholder: 'עותק של המסמך המקורי',
                duplicate: 'צור עותק',
                cancel: 'ביטול'
            },
            success: 'המסמך שוכפל בהצלחה! כעת ניתן לערוך את העותק החדש.',
            error: 'שכפול המסמך נכשל. אנא נסה שוב.'
        },
        questionSection: {
            pleaseSelectAnswer: 'אנא בחר תשובה',
            correct: 'נכון! התשובה שלך נכונה.',
            incorrect: 'שגוי. אנא נסה שוב.',
            submitError: 'שגיאה בשליחת התשובה. אנא נסה שוב.',
            submit: 'שלח תשובה',
            alreadyCompleted: 'כבר עניתם על שאלה זו בהצלחה'
        },
        sequentialActiveVersionModal: {
            title: 'להחליף את הגרסה הפעילה?',
            message: (key, {activeVersionName}) => `"${activeVersionName}" היא הגרסה הפעילה הנוכחית של תוכן מחזורי זה.`,
            subMessage: 'רק גרסה אחת יכולה להיות פעילה בכל זמן. הפעלת גרסה זו תעביר את הקודמת לארכיון. משתמשים שהוקצו לגרסה הקודמת יקבלו שיוך גם לגרסה החדשה, והגרסה הקודמת תופיע באזור הארכיון שלהם.',
            declineButton: 'ביטול',
            agreeButton: 'החלף והפעל'
        }
    },
    learningManagement: {
        createEditNewSignDocModal: {
            approversSection: {
                title: 'בחירת מאשרים (אופציונלי)',
                description: 'בחר משתמשים ספציפיים שיוכלו לאשר העלאות. אם לא תבחר, כל מנהלי היחידות הארגוניות שהמשימה משוייכת אליהן יהיו מאשרים.',
                userLabel: 'בחר משתמשים ספציפיים כמאשרים',
                defaultInfo: 'אם לא תבחר משתמשים ספציפיים, רק אתה או מנהלי החברה יוכלו לאשר העלאות'
            },
            individualUsersSection: {
                title: 'הקצאה אישית למשתמשים',
                userLabel: 'חפש משתמשים להקצאה אישית',
                searchLabel: 'חיפוש משתמשים',
                searchPlaceholder: 'הקלד שם, טלפון אימייל או תעודת זהות...',
                noUsersFound: 'לא נמצאו משתמשים התואמים את החיפוש',
            },
            // Organization search
            organizationsSection: {
                searchLabel: 'חיפוש יחידה ארגונית',
                searchPlaceholder: 'הקלד שם יחידה ארגונית...',
            },
            // User pagination labels
            noUsers: 'לא נמצאו משתמשים',
            selectedLabel: 'משתמשים נבחרו',
            noOrganizations: 'לא נמצאו יחידות ארגוניות',
            selectedOrgsLabel: 'יחידות ארגוניות נבחרו',
            userPaginationError: 'שגיאה בטעינת משתמשים',
            userPaginationErrorMessage: 'לא ניתן לטעון את רשימת המשתמשים. אנא נסה שוב באמצעות חיצי הניווט.',
            orgPaginationError: 'שגיאה בטעינת יחידות ארגוניות',
            orgPaginationErrorMessage: 'לא ניתן לטעון את רשימת היחידות הארגוניות. אנא נסה שוב באמצעות חיצי הניווט.',
            uploadError: 'העלאת הקובץ נכשלה',
            uploadErrorMessage: 'ההעלאה נכשלה. אנא נסה שוב.'
        }
    },
    pendingApprovals: {
        title: 'אישורים ממתינים',
        description: 'סקור ואשר או דחה העלאות מסמכים של משתמשים',
        searchPlaceholder: 'חפש לפי שם משתמש או משימה...',
        noData: 'אין אישורים ממתינים',
        tabs: {
            documentApprovals: 'אישור מסמכים',
            courseAttendance: 'נוכחות בקורסים'
        },
        columns: {
            userName: 'שם משתמש',
            phone: 'טלפון',
            idNumber: 'מספר זהות',
            signDocName: 'שם המשימה',
            uploadDate: 'תאריך העלאה',
            organization: 'יחידה ארגונית',
            files: 'קבצים',
            actions: 'פעולות'
        },
        actions: {
            approve: 'אשר',
            reject: 'דחה'
        },
        approveDialog: {
            title: 'אישור העלאה',
            user: 'משתמש',
            signDoc: 'משימה',
            confirmMessage: 'האם לאשר העלאה זו?',
            expiryDescription: 'הסמכה זו דורשת הזנת תאריך תפוגה ידני. בחר את התאריך בו ההסמכה תפוג.',
            expiryDateLabel: 'תאריך תפוגת ההסמכה',
            expiryDateRequired: 'יש להזין תאריך תפוגה להסמכה',
            expiryDatePast: 'תאריך התפוגה חייב להיות בעתיד',
            cancel: 'ביטול',
            confirm: 'אשר העלאה'
        },
        rejectDialog: {
            title: 'דחיית העלאה',
            reasonLabel: 'סיבת דחייה (אופציונלי)',
            reasonPlaceholder: 'הסבר למשתמש מדוע ההעלאה נדחתה...',
            deleteFilesLabel: 'מחק קבצים שהועלו מהשרת',
            cancel: 'ביטול',
            confirm: 'דחה העלאה'
        },
        errors: {
            approveFailed: 'שגיאה באישור ההעלאה. אנא נסה שוב.',
            rejectFailed: 'שגיאה בדחיית ההעלאה. אנא נסה שוב.'
        }
    },
    courseAttendance: {
        title: 'נוכחות בקורסים',
        description: 'סמן נוכחות או היעדרות עבור משתמשים שנרשמו לקורסים',
        searchPlaceholder: 'חפש לפי שם משתמש או קורס...',
        noData: 'אין קורסים ממתינים לסימון נוכחות',
        columns: {
            userName: 'שם משתמש',
            phone: 'טלפון',
            idNumber: 'מספר זהות',
            courseName: 'שם הקורס',
            courseType: 'סוג קורס',
            sessionDate: 'תאריך המפגש',
            actions: 'פעולות'
        },
        courseTypes: {
            frontal: 'פרונטלי',
            online: 'מקוון'
        },
        actions: {
            markAttended: 'סמן כנוכח',
            markNoShow: 'סמן כלא התייצב'
        },
        tooltips: {
            sessionNotToday: 'ניתן לסמן נוכחות רק ביום המפגש'
        },
        errors: {
            markAttendedFailed: 'שגיאה בסימון הנוכחות. אנא נסה שוב.',
            markNoShowFailed: 'שגיאה בסימון אי ההתייצבות. אנא נסה שוב.'
        },
        filters: {
            allCourses: 'כל הקורסים'
        }
    },
    userProgressReport: {
        exportToExcel: 'ייצוא לאקסל',
        exporting: 'מייצא...',
        exportCurrentFilters: 'ייצוא סינונים נוכחיים',
        columns: {
            fullName: 'שם מלא',
            firstName: 'שם פרטי',
            lastName: 'שם משפחה',
            phone: 'טלפון',
            idNumber: 'מספר זהות',
            employeeId: 'מספר עובד',
            chosenOrganizationUnitsProgress: 'התקדמות משימות ביחידות שנבחרו',
            allManagedProgress: 'התקדמות בכלל המשימות',
            completionStatus: 'סטטוס השלמה',
            organizations: 'יחידות ארגוניות',
            userDetails: 'פרטי משתמש'
        },
        completionStatus: (key, { completed, total }) => `${completed} מתוך ${total} הושלמו`,
        tasksCompleted: 'משימות שהושלמו',
        pieChart: {
            title: 'ביצועי כל המשימות של עובדים בארגון',
            subtitle: 'התפלגות מטלות לפי סטטוס',
            selectedOrgsTitle: 'התקדמות העובדים במשימות שהוקצו ביחידות הנבחרות',
            selectedOrgsSubtitle: 'התפלגות מטלות ביחידות הנבחרות',
            selectedOrgsInfoBubble: 'תרשים זה מציג את התפלגות המשימות של העובדים ביחידות הארגוניות שנבחרו בפילטרים. הוא כולל רק משימות שהוקצו לעובדים ביחידות הנבחרות.',
            allManagedTitle: 'התקדמות כלל משימות העובדים ביחידות שנבחרו',
            allManagedSubtitle: 'התפלגות כל המטלות תחת הניהול',
            allManagedInfoBubble: 'תרשים זה מציג את התפלגות כלל המשימות של העובדים בכל היחידות הארגוניות שאתה מנהל, ללא קשר לפילטרים שנבחרו. זה נותן תמונה כוללת של כל המטלות תחת הניהול שלך.',
            completed: 'משימות שהושלמו',
            inProgress: 'משימות בתהליך',
            notStarted: 'משימות שלא החלו',
        }
    },
    certificationDashboard: {
        title: 'לוח בקרת הסמכות',
        subtitle: 'מעקב אחר סטטוס הסמכות ותוקף',
        tasksCompleted: 'הושלמו',
        columns: {
            fullName: 'שם מלא',
            status: 'סטטוס',
            phone: 'טלפון',
            organizations: 'יחידות ארגוניות',
            idNumber: 'תעודת זהות',
            employeeId: 'מספר עובד',
            chosenOrganizationUnitsProgress: 'התקדמות ביחידות נבחרות',
            allManagedProgress: 'התקדמות כוללת',
            userDetails: 'פרטי משתמש',
        },
        pieChart: {
            selectedOrgsTitle: 'סטטוס ארגונים נבחרים',
            selectedOrgsSubtitle: 'התפלגות סטטוס הסמכות',
            selectedOrgsInfoBubble: 'סטטוס הסמכות עבור הארגונים שנבחרו',
            allManagedTitle: 'סטטוס כלל הארגונים',
            allManagedSubtitle: 'התפלגות סטטוס הסמכות',
            allManagedInfoBubble: 'סטטוס הסמכות עבור כלל הארגונים המנוהלים',
        }
    },
    certificationStatus: {
        expired: 'פג תוקף',
        expiringSoon: 'עומד לפוג',
        incomplete: 'בתהליך',
        completed: 'הושלם',
    },
    certifications: {
        category: 'קטגוריה',
        categoryForceCompletion: 'נדרש לבצע',
        categoryCertification: 'הסמכות',
        categoryKnowledgeCenter: 'מרכז ידע',
        categoryChangeDisabled: {
            multipleVersions: 'לא ניתן לשנות קטגוריה כאשר קיימות מספר גרסאות'
        },
        expiryDuration: {
            toggleLabel: 'הוסף תוקף להסמכה',
            title: 'תוקף ההסמכה',
            valueLabel: 'משך תוקף',
            unitLabel: 'יחידת זמן',
            units: {
                years: 'שנים',
                months: 'חודשים',
                days: 'ימים'
            },
            note: 'הגדר תוקף להסמכה. המערכת תחשב את תאריך התפוגה מתאריך השלמת ההסמכה.'
        },
    },
    durationPicker: {
        label: 'משך זמן להשלמה',
        valueLabel: 'כמות',
        valuePlaceholder: 'הזן ערך',
        unitPlaceholder: 'בחר יחידה',
        MINUTES: 'דקות',
        DAYS: 'ימים',
        MONTHS: 'חודשים',
        YEARS: 'שנים',
        errorInvalidValue: 'אנא הזן מספר חיובי'
    },
    courseFields: {
        sessionStartDate: 'תאריך ושעת התחלה',
        sessionDuration: 'משך השיעור (בדקות)',
        location: 'מיקום (כתובת/חדר)',
        meetingLink: 'קישור לפגישה (Zoom/Google Meet)',
        instructor: 'שם המדריך',
        onlineSession: 'שיעור מקוון',
        invalidMeetingLink: 'יש להזין קישור פגישה תקין מפלטפורמה מוכרת (Zoom, Microsoft Teams, Google Meet, Webex, GoToMeeting, Jitsi, Whereby וכו\')',
    },
    selectDurationModal: {
        titleOrg: 'הגדר משך זמן עבור יחידה ארגונית',
        titleUser: 'הגדר משך זמן עבור משתמש',
        durationLabel: 'זמן להשלמת המשימה',
        explanation: 'משתמשים יקבלו מועד להשלמה המחושב מתאריך ההקצאה שלהם. לדוגמה, אם תגדיר 60 ימים, משתמש שהוקצה היום יקבל 60 ימים להשלים את המשימה.'
    }
,
    addToHomeScreen: {
        title: 'התקן את האפליקציה',
        description: 'התקן את WeezBee במכשיר שלך לגישה מהירה וחוויית שימוש משופרת.',
        install: 'התקן כעת',
        dismiss: 'הבנתי תודה!',
        neverAskAgain: 'אל תציג שוב',
        benefits: {
            faster: 'גישה מהירה יותר',
            offline: 'עבודה גם ללא אינטרנט',
            homeScreen: 'קיצור דרך במסך הבית'
        },
        iosInstructions: {
            title: 'כדי להתקין את האפליקציה באייפון שלך:',
            step1Part1: 'לחץ על כפתור "שיתוף"',
            step1Part2: '- נמצא בשורת הכתובת או בתפריט',
            step2: 'גלול למטה ברשימה שנפתחה',
            step3: 'לחץ על "הוסף למסך הבית"',
            step4: 'לחץ על "הוספה" בפינה העליונה כדי לסיים'
        }
    }
}
